webpackJsonp([1],{

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HXhP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dda45688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("uvmt")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45475472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("HXhP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6be6e2d9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("OT+5")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63a4c432","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("RkWL")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 60
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a87b78e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?void 0:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("q5L0")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "Revue Olympique - Numero 120",
  "shortTitle": "",
  "description": "",
  "width": 719,
  "height": 890,
  "currentLanguage": "FR",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "http://olympicreview.touchlines.com/120"
  }, {
    "code": "FR",
    "text": "French",
    "href": "http://revueolympique.touchlines.com/120"
  }],
  "basePath": "/120",
  // "basePath": "",
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://revue-olympique.s3-website-eu-west-1.amazonaws.com/120/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": true,
    "rightToLeft": false,
    "searchEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": true,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 1-head\" style=\"top:12px;left:1px\" src=\"/120/static/_content/1-title-1.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:133px;left:223px\" src=\"/120/static/_content/1-title-2.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:11px;left:236px\" src=\"/120/static/_content/1-title-3.png\"/>\n        <img class=\"halfScale 1-title\" style=\"top:132px;left:585px\" src=\"/120/static/_content/1-title-4.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:262px;left:218px\" src=\"/120/static/_content/1-sub-1.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:308px;left:240px\" src=\"/120/static/_content/1-sub-2.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:232px\" src=\"/120/static/_content/1-sub-3.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:386px\" src=\"/120/static/_content/1-sub-4.png\"/>\n        <img class=\"halfScale 1-sub\" style=\"top:374px;left:513px\" src=\"/120/static/_content/1-sub-5.png\"/>\n        <img id=\"1-logo-1\" class=\"halfScaleC\" style=\"top:812px;left:-27px\" src=\"/120/static/_content/1-logo-1.png\"/>\n        <img class=\"halfScale 1-link\" style=\"top:864px;left:634px\" src=\"/120/static/_content/1-link-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:860px;left:626px;height:16px;width:82px;\">\n          <a href=\"https://olympics.com/fr/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax();\n          pg1Anim\n            .fromTo(cOf(\"1-head\"), 0.8, {opacity:0, y:-228},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n            .staggerFromTo(cOf(\"1-title\"), 0.6, {opacity:0, y:50},{opacity:1, y:0, ease: Power2.easeOut}, 0.3, 1.3)\n            .staggerFromTo(cOf(\"1-sub\"), 0.4, {opacity:0, x:30},{opacity:1, x:0, ease: Power2.easeOut}, 0.3, 1.9)\n            .fromTo(idOf(\"1-logo-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, \"-=0.2\", 1)\n            .fromTo(cOf(\"1-link\"), 0.6, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 3.6)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "REVUE  Olympique Juillet 2023 Numéro 120  Publication officielle du Mouvement olympique  Paris – hier et aujourd’hui Un an avant le début des Jeux Olympiques et Paralympiques de Paris 2024, les organisateurs allient tradition et innovation.  Il y a 100 ans, Paris 1924 établissait les fondements des traditions olympiques.  Un aperçu du long et difficile chemin en vue de la parité hommes-femmes dans le sport.  Quelques points de vue sur Paris 2024, alors que la ville se prépare pour ses troisièmes Jeux d’été.  olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MERCI À NOS PARTENAIRES OLYMPIQUES MONDiAUX"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <img id=\"4-title-1\" class=\"halfScale\" style=\"top:114px;left:43px\" src=\"/120/static/_content/4-title-1.png\"/>\n        <img id=\"4-sub-1\" class=\"halfScale\" style=\"top:178px;left:43px\" src=\"/120/static/_content/4-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(6)\" style=\"top:369px;left:51px;width:113px;height:90px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(8)\" style=\"top:693px;left:49px;width:123px;height:114px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(12)\" style=\"top:312px;left:343px;width:131px;height:127px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(14)\" style=\"top:712px;left:267px;width:330px;height:111px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(36)\" style=\"top:335px;left:506px;width:148px;height:103px\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.fromTo(idOf(\"4-title-1\"), 0.8, {opacity:0, y:-40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"4-sub-1\"), 0.4, {opacity:0, x:-40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg4Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "4  Sommaire  sommaire publIcatIon offIcIelle du mouvement olympIque juIllet 2023  6  avant-propos  Par le président du CIO, Thomas Bach.  8  henry kIssInger  La Revue Olympique rend hommage au membre d’honneur du CIO pour son 100e anniversaire.  12  au-del‡ des anneaux  Nous devrions nous employer à ce que tous les athlètes puissent participer aux compétitions, estime Karl Friedrich Wessel.  14 parIs 1924  36  de 1924 ‡ 2024  Explorez un siècle d’histoire olympique de Paris grâce à des cartes des Jeux de 1924 et 2024.  Une série d’articles d’opinion par des auteurs extérieurs au Mouvement olympique: Thierry Terret décrit comment Paris 1924 a marqué un tournant dans l’histoire olympique; George Hirthler se penche sur la façon dont ces Jeux ont permis à Pierre de Coubertin de faire ses adieux; et Florence Carpentier retrace la naissance et le développement du sport féminin."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(40)\" style=\"top:155px;left:181px;width:89px;height:125px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(42)\" style=\"top:228px;left:326px;width:138px;height:93px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(52)\" style=\"top: 566px; left: 50px; width: 450px; height: 109px;\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(76)\" style=\"top:702px;left:50px;width:98px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(80)\" style=\"top:702px;left:164px;width:98px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(82)\" style=\"top:702px;left:279px;width:128px;height:151px\"></div>\n        <div class=\"addContentLinkThree\" onclick=\"Publish.goToPage(84)\" style=\"top:702px;left:419px;width:98px;height:151px\"></div>\n\n\n        <div class=\"addContentLinkThree\" style=\"top:619px;left:571px;height:10px;width:77px;\">\n          <a href=\"https://www.olympics.com/cio\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:627px;left:553px;height:10px;width:89px;\">\n          <a href=\"mailto:olympicreview@olympic.org\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Revue Olympique  5  Numéro 120  comItÈ exÈcutIf Président Thomas Bach Vices-Présidents Ser Miang Ng, John Coates AC, Nicole Hoevertsz, Juan Antonio Samaranch Membres Robin E. Mitchell, Denis Oswald, Nenad Lalovic, Ivo Ferriani, SAR le Prince Feisal Al Hussein, Nawal El Moutawakel, Mikaela Cojuangco Jaworski, Gerardo Werthein, Kristin Kloster, Emma Terho  40  vIllage olympIque  Paris 2024 marquera un siècle d’existence du village olympique aux Jeux.  revue olympIque  42  ‡ travers líobjectIf  Une exploration en photos de Paris en 1924 et aujourd’hui.  Directeur de la communication institutionnelle et des affaires publiques Christian Klaue Rédactrice en chef Katharine Mann Co-rédactrice en chef et édition française Lucile Tonnerre Édition espagnole Dolores Blázquez Agence de production Touchline Production Michael Stoneman, Glyn Wilmshurst, John Murray, Sam Price, Conor Ketley Design Liz Rankin, Shyama Rajani, Apostolis Tatasopoulos Retouche d’image Liz Rankin Secrétariat de rédaction Quentin Huon Traduction Aurélien Sagnier Relecture Fréderic Brunet ISSN: 0251-3498 Imprimée au Royaume-Uni  Images Couverture: Getty Images Intérieur: IOC; IOC/Greg Martin; IOC/ Philippe Woods; IOC/Giulio Locatelli; IOC/ Marcel Imsand; IOC/Christophe Moratal; IOC/Nelson Chavez; IOC/Jason Evans; IOC/ Bob Long; IOC/United Archives; Kishimoto/ IOC; Getty Images; Comité d’organisation des Jeux Olympiques et Paralympiques Paris 2024; Henri Garat/Ville de Paris; Sophie Robichon/Ville de Paris; Philippe Millereau/Ville de Paris; Emilie Chaix/Ville de Paris; ©Société de livraison des ouvrages olympiques – SOLIDEO/ILLUMINENS©/ Dominique Perrault/Ingérop/Une Fabrique de la Ville/VITEC/Agence TER/UrbanEco/JeanPaul Lamoureux; ©SOLIDEO – Dronepresse; Jean-Marie Hervio/KMSP; Little Shao/Red Bull Content Pool; Myriam Fox-Jerusalmi; CNOSF; BOA; Bill Morris  52 parIs 2024  Des contributeurs extérieurs au Mouvement olympique se projettent dans des Jeux d’une nouvelle ère: Alain Lunzenfichter explique ce à quoi on peut s’attendre à Paris dans un an; Michel Cadot, Tony Estanguet et Pierre Rabadan partagent leur point de vue depuis la capitale française; des athlètes d’hier et d’aujourd’hui livrent leur analyse sur la manière dont les Jeux peuvent être transformateurs; et l’entraîneure Myriam Fox-Jerusalmi explore l’importance de l’égalité des genres parmi les athlètes.  76  opInIon  Sir Hugh Robertson et Bill Morris partagent leurs avis sur l’organisation des Jeux Olympiques et leur impact positif sur les villes hôtes.  80  82  Les parutions recensées par le Centre d’études olympiques du CIO.  Les olympiens et les personnalités du Mouvement olympique qui nous ont quittés.  Ètudes olympIques  dÈcËs  84  le mot de la fIn  Les Jeux pionniers de 1924 et 2024.  Écrivez-nous à: Revue Olympique Département de la communication institutionnelle et des affaires publiques, Maison Olympique, 1007 Lausanne, Suisse Site internet: www.olympics.com/cio E-mail: olympicreview@olympic.org Tél.: +41 (0)21 621 61 11  La Revue Olympique est imprimée sur du papier certifié PEFC fabriqué à partir de bois de forêts gérées dans le souci du développement durable. La Revue Olympique est publiée par le Comité International Olympique. Les articles publiés dans la Revue Olympique ne reflètent pas nécessairement les opinions du CIO. Toute reproduction sans l’accord du département de la communication institutionnelle et des affaires publiques du CIO est interdite.  Toutes les informations sont correctes au moment de l’impression  contacts"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <img id=\"6-title-1\" class=\"halfScale\" style=\"top:94px;left:42px\" src=\"/120/static/_content/6-title-1.png\"/>\n        <img id=\"6-quote-1\" class=\"halfScale\" style=\"top:581px;left:476px\" src=\"/120/static/_content/6-quote-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:597px;left:474px;height:16px;width:80px;\">\n          <a href=\"https://www.paris2024.org/fr/\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg6Anim = new TimelineMax();\n          pg6Anim.fromTo(idOf(\"6-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"6-quote-1\"), 0.4, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg6Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "6  Avant-propos  avant-propos de thomas bach  D  ans un an, la ville de Paris et la France accueilleront le monde entier aux Jeux Olympiques. L’excitation va déjà grandissante pour ce qui promet d’être un festival du sport spectaculaire, dans l’une des destinations les plus emblématiques qui soit. Cent ans se sont écoulés depuis la dernière édition organisée dans la capitale française, et Paris 2024 marquera le début d’une nouvelle ère. Il s’agira des premiers Jeux à bénéﬁcier pleinement des réformes de l’Agenda olympique 2020 de bout en bout. L’ambition des organisateurs n’est pas seulement de mettre les Jeux Olympiques au cœur de la ville, mais de mettre la ville au cœur des Jeux. Cette vision se reﬂète dans l’ajout de nombreuses innovations. Prenant le contrepied des précédentes éditions, la cérémonie d’ouverture s’émancipera des stades: la parade des  1 Paris 2024 met en place des innovations permettant à la ville et ses habitants d’être au cœur des Jeux.  athlètes se déroulera sur des barges, le long de la Seine. Le but est qu’un demi-million de personnes puissent se rassembler sur les quais du ﬂeuve pour acclamer les athlètes qui navigueront à travers Paris. Par ailleurs, de nombreuses compétitions sportives auront pour décor les plus célèbres monuments parisiens. Par souci de durabilité, 95% des sites existent déjà ou seront temporaires. Les épreuves d’équitation se dérouleront dans les jardins du château de Versailles, tandis que le beach volley se disputera sur le Champ-de-Mars. Le triathlon et les courses en eau libre débuteront au pied du pont Alexandre III, sur la Seine, à quelques encablures de la tour Eiffel. Certains des lieux les plus prestigieux de Paris se transformeront en sites de compétition. Le Grand Palais accueillera les compétitions de taekwondo et d’escrime, et les épreuves de tir à l’arc auront lieu sur l’esplanade des Invalides. Les visiteurs assistant aux Jeux pourront explorer et savourer Paris en se déplaçant d’un site à l’autre, à pied ou en transports en commun, combinant ainsi les Jeux et la visite de la Ville lumière. Les organisateurs ont également l’intention d’impliquer le grand public dans les activités sportives. C’est en ce sens que le «Marathon Pour Tous» offrira l’occasion à chacun de se confronter aux meilleurs athlètes de la planète en empruntant le même parcours que le marathon olympique, un tracé symbolique entre Paris et Versailles intimement lié à l’histoire de la France. L’objectif est d’attribuer autant de dossards aux hommes qu’aux femmes, qui auront l’occasion de dire qu’ils ont «participé aux Jeux Olympiques». Un autre élément fera date: Paris 2024 sera la première édition de l’histoire des Jeux à voir participer un nombre égal de femmes et d’hommes (5 250 athlètes de  1  «En plus d’être paritaire, Paris 2024 fera la part belle à la jeunesse, avec l’inscription au programme de quatre sports privilégiés par les jeunes.»  chaque sexe) dans le même nombre de compétitions. Par contraste, les femmes représentaient seulement 4% des compétiteurs en 1924. Il s’agit là d’un point capital. Toutefois, l’égalité des genres n’est pas la seule innovation. En plus d’être parfaitement paritaire, Paris 2024 fera la part belle à la jeunesse, avec l’inscription au programme de quatre sports privilégiés"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div id=\"7-sig\" class=\"abs noOverflow\" style=\"top: 781px; left: 478px; height: 43px; width: 142px;background:white\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg7Anim = new TimelineMax()\n          pg7Anim\n            .fromTo(idOf(\"7-sig\"), 0.6, {width:142,x:0}, {width: 0,x:142, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg7Anim.stop()\n          removeContentLinks();\n        }\n      ",
    "searchText": "par les jeunes: le breaking, le skateboard, l’escalade sportive et le surf. Fidèles à leur ambition d’impliquer l’ensemble de la France dans les Jeux Olympiques, y compris les territoires d’outre-mer, les organisateurs ont décidé que la compétition de surf se déroulerait à Tahiti. Dans les pages qui suivent, vous pourrez découvrir ce que les athlètes et visiteurs de Paris 2024 peuvent espérer vivre. Grâce aux témoignages des athlètes et personnalités du comité d’organisation et de la France, il est possible d’avoir un avant-goût de ce qui nous attend aux Jeux Olympiques de Paris 2024. Nous retraçons également le développement du sport féminin en France et aux Jeux Olympiques, et mettons à l’honneur le travail préparatoire qui a mené à l’égalité des genres dont nous serons témoins l’an prochain.  Les projets d’héritage de Paris 2024 sont également en bonne voie, grâce à des initiatives telles que «Terre de Jeux 2024», qui encourage la pratique sportive chez les enfants et les jeunes de tout le pays. Il est toutefois impossible de parler de 2024 sans mentionner le passé, et notamment les Jeux Olympiques de Paris 1924. Car si cette édition s’est déroulée il y a un siècle, elle n’en était pas moins innovante pour son temps, et son héritage a posé les fondations de tant de choses qui font désormais partie intégrante des Jeux. Nous rendons donc hommage aux Jeux de 1924, leur déroulement et la manière dont ils ont transformé Paris, la France et les Jeux Olympiques. Ces Jeux ont aussi été le chant du cygne de Pierre de Coubertin, le rénovateur des Jeux Olympiques modernes: la Revue Olympique lui o)re donc un tribut.  Paris 1924 a marqué de nombreuses grandes premières, dont le premier village olympique, les premières cérémonies o)icielles d’ouverture et de clôture, ainsi que l’émergence de certaines des premières superstars mondiales du sport. Tous ces domaines sont explorés dans nos papiers historiques dédiés à cette édition. Alors que monte l’excitation pour les Jeux de la XXXIIIe Olympiade, il ne me reste plus qu’à vous donner rendez-vous à Paris en 2024! ■  Thomas Bach, président du CIO"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 8-title\" style=\"top:594px;left:44px\" src=\"/120/static/_content/8-title-1.png\"/>\n        <img class=\"halfScale 8-sub\" style=\"top:801px;left:44px\" src=\"/120/static/_content/8-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:801px;left:268px;width:125px;height:13px;\"><a href=\"https://olympics.com/ioc/news/ioc-president-pays-tribute-to-honour-member-henry-kissinger-as-he-celebrates-his-100th-birthday \" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg8Anim = new TimelineMax();\n          pg8Anim.fromTo(cOf(\"8-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"8-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1500)\n        }\n\n        function onPageLeave() {\n          pg8Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "un amI de longue date du mouvement olympIque  À L’OCCASION DU 100E ANNIVERSAIRE D’HENRY KISSINGER, LA REVUE OLYMPIQUE REND HOMMAGE AU RÔLE JOUÉ AU SEIN DU MOUVEMENT OLYMPIQUE PAR CE MEMBRE D’HONNEUR DU CIO ET ANCIEN SECRÉTAIRE D’ÉTAT DES ÉTATS-UNIS. PAR ALAN ABRAHAMSON"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "9  I  1  1 Henry Kissinger a toujours été un proche conseiller du président Thomas Bach. 2 Kissinger et Bach au Musée Olympique en 2019.  l y a quelques années, dans l’illustre 21 Club de New York, le Comité Olympique des États-Unis (USOC) remettait à Henry Kissinger le prix Douglas MacArthur. Pour la plupart des gens, le nom du général MacArthur évoque l’image du militaire qui a dirigé le Commandement des forces des Nations Unies lors de la guerre de Corée, avec sa casquette d’officier, sa pipe et ses lunettes de soleil Ray-Ban. MacArthur a pourtant joué un rôle moins connu aux Jeux Olympiques d’Amsterdam de 1928. L’année précédente, le président de l’USOC était décédé et MacArthur était pressenti pour le remplacer. C’était un choix logique: aux États-Unis, il était connu pour son implication dans les sports à West Point, la prestigieuse académie militaire américaine, ainsi que dans le sport amateur en général. MacArthur a accepté le poste avec enthousiasme. Il faut bien comprendre qu’à l’époque, l’avenir des Jeux était bien différent de ce que nous connaissons. Le monde également: la guerre avait fait des ravages, la diffusion des Jeux Olympiques à la télévision était un rêve lointain, les Jeux modernes avaient seulement 30 ans d’ancienneté… L’édition 1932 avait été accordée à Los Angeles, mais les États-Unis s’interrogeaient sur le budget et l’énergie à allouer à cette Olympiade. La Californie se situait bien loin des sphères politiques et ﬁnancières de Washington et New York, et l’horizon des cinq ans semblait être aussi loin temporellement qu’Amsterdam ne l’était géographiquement. Les Jeux Olympiques semblaient quelque peu à un point d’inﬂexion. Le prix Douglas MacArthur – désormais décerné par l’entité rebaptisée Comité Olympique et Paralympique des États-Unis (USOPC) – est attribué aux personnes ayant fait preuve d’un «service exemplaire», à l’image de ce qu’a réalisé MacArthur en 1928. Dans la biographie que lui a consacrée l’historien Arthur Herman en 2016, l’auteur explique qu’il a sauvé la relation entre les Jeux Olympiques et les États-Unis – voire le monde entier. La délégation américaine envoyée aux Pays-Bas est revenue avec 22 médailles d’or, tout en établissant 17 records olympiques et sept records mondiaux. Accélérons le temps jusqu’à la ﬁn du millénaire. Touché par une série de révélations sur la candidature gagnante de Salt Lake City pour les Jeux Olympiques d’hiver 2002, le CIO  a initié une vaste réforme qui s’est concrétisée sous la forme d’un programme en 50 points. Six membres du CIO ont été exclus et quatre ont démissionné. Kissinger a joué un rôle clé en coulisse dans la supervision des réformes, ce qui lui a valu le prix Douglas MacArthur de l’USOC et le titre de membre d’honneur du CIO. Le parallèle est évident: le Mouvement olympique était à un nouveau point d’inﬂexion. Le soir de la remise de cette récompense au 21 Club, Kissinger a déclaré: «Même un doctorat en diplomatie ne serait d’aucune aide pour naviguer les complexités du CIO.» Une déclaration forte venant d’un homme aussi expérimenté en géopolitique. Kissinger a fêté au printemps dernier son 100e anniversaire, l’occasion de rappeler son rôle clé dans le Mouvement olympique, même s’il a toujours œuvré loin de la lumière des projecteurs. Il a répondu présent lors de la pire crise vécue par le CIO, en 1999 et 2000, puis en étant un proche conseiller de Thomas Bach lors de sa présidence. Comme l’explique Bach, les deux hommes se sont rencontrés lors des réformes de la Commission CIO 2000. Juan Antonio Samaranch, le président du CIO de l’époque, avait invité 82 personnalités et dignitaires du monde entier (chefs d’entreprise, athlètes, diplomates) qu’il avait répartis en trois groupes de travail. Bach, médaillé d’or en escrime et membre du CIO depuis environ 10 ans à ce moment-là, a dirigé le panel chargé d’examiner «le rôle du CIO». Kissinger ﬁgurait dans ce même groupe.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "10  1  Parmi ses passions, Bach est féru d’histoire, il a lu les mémoires exhaustifs de Kissinger. Les deux hommes sont d’ailleurs issus de la même région allemande, la Franconie – même si Kissinger avait quitté le pays avec sa famille juive en 1938 pour fuir le régime nazi. Pourtant avocat émérite et homme politique de renom sur la scène olympique, Bach a reconnu qu’il était nerveux de rencontrer Kissinger. L’ancien Secrétaire d’État américain a vite dissipé ses inquiétudes en lui glissant quelques mots en allemand pour briser la glace. «Kissinger était un leader parmi toutes ces personnalités», décryptait plus tard Bach, évoquant plusieurs raisons. D’une part, le «génie» de Kissinger, comme l’a décrit Bach: «Il a la capacité de prendre n’importe quel problème que vous lui soumettez et de l’inclure à l’échelle mondiale, sans jamais perdre de vue le contexte national particulier.» Par ailleurs, sa perspective ne se limite pas au présent, mais aussi à «ce à quoi cela pourrait amener». D’autre part, Kissinger est un homme qui a les pieds sur terre et un grand sens de l’humour. «Il est très sec sur le plan analytique, mais il a une personnalité très chaleureuse». Ceux qui l’ont côtoyé n’ont pas seulement remarqué cette dualité: ils l’ont trouvée remarquable. «Il est absolument brillant et concis. Il parvient à saisir la pertinence de  n’importe quel événement et de l’expliquer en trois ou quatre phrases», décrivait Bill Hybl, ancien membre du CIO, deux fois président de l’USOC et membre de CIO 2000. «Chez lui, il avait plein de télévisions aﬁn de pouvoir suivre quasiment tous les matches de NFL en même temps», racontait-il, dans un sourire admiratif. «C’est peut-être encore le cas, je ne sais pas. Il adore vraiment le sport.» Mitt Romney est aujourd’hui sénateur de l’Utah (États-Unis) après avoir été candidat républicain à l’élection présidentielle de 2012 et gouverneur du Massachusetts entre 2003 et 2007. Au cœur de la crise vécue par le CIO, il a été chargé de diriger le comité d’organisation de Salt Lake City 2002: «Dans un monde qui se tourne vers les "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "WORLDWIDE PARTNER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 12-title\" style=\"top:158px;left:42px\" src=\"/120/static/_content/12-title-1.png\"/>\n        <img class=\"halfScale 12-sub\" style=\"top:253px;left:43px\" src=\"/120/static/_content/12-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg12Anim = new TimelineMax();\n          pg12Anim.fromTo(cOf(\"12-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"12-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg12Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "12  Au-delà des anneaux  au-del‡ des anneaux  Sport et paix Nous devrions toujours nous employer à ce que tous les athlètes puissent participer aux compétitions, plutôt que d’utiliser le sport pour creuser les fractures, estime Karl-Friedrich Wessel.  1  L  orsqu’un appel à se mobiliser pour la paix est lancé, s’il s’adresse aux organismes sportifs et aux églises, et pas seulement en lien avec la guerre entre la Russie et l’Ukraine, il est impératif d’y répondre, même sous une forme différente – avec un stylo et du papier. Il est logique de mettre le sport sur le devant de la scène, ce qui représente  un défi particulier pour les athlètes et les spécialistes du sport. En effet, aucun autre système social n’intéresse autant le public que le sport. La responsabilité des membres de ce système est d’autant plus grande. Le sport, c’est-à-dire l’ensemble de ce système très ramifié, est tributaire de la paix. Il est donc particulièrement menacé par les conflits. Ceci revêt une grande importance,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  13  Numéro 120  car le sport est indispensable pour tous les individus tout au long de leur ontogenèse – de leur conception à leur mort. Le sport est un besoin fondamental. Même si beaucoup n’en ont pas conscience; c’est un besoin anthropologique. C’est précisément à une époque où de nombreux individus sont de plus en plus sédentaires qu’il acquiert la qualité nécessaire à la vie. Si l’être humain peut vivre sans pratiquer de sport et se contenter d’observer les athlètes, sans implication physique ou mentale, la notion de sport est totalement détournée de son sens. Elle se limite alors à regarder un écran ou à lire des journaux. Il n’y a rien à redire à cela, puisqu’on ne peut y remédier. En outre, cela ne fait que souligner le rôle pacificateur du sport, car quiconque souhaite continuer à jouir de ses bienfaits devrait tout autant s’inscrire dans une démarche pacifique que ceux qui militent activement en faveur de la paix pour des raisons anthropologiques. Je ne veux en aucun cas nier le fait qu’un comportement visible et exemplaire dans le sport peut constituer un important levier, si les athlètes et les officiels sportifs assument leurs responsabilités. Car il ne s’agit pas de défendre ou de répéter une quelconque opinion politique, mais d’adopter une position tout à fait indépendante conforme à la nature même du sport. Le sport est issu d’une longue évolution culturelle, il est lié à l’histoire mondiale et, même si on ne pratique pas de sport, sa pratique est aussi liée au développement individuel des personnalités. Le sport est le reflet de la compétition ancestrale entre les individus. Un individu peut difficilement se comparer à lui-même, au mieux il peut mesurer sa propre évolution, mais il a surtout besoin de l’autre pour se confronter à lui. Ainsi, la bagarre entre enfants est une forme de comparaison, et pas seulement physique. Dès les premiers cours d’éducation physique, le sport incarne cette confrontation, mais celle-ci repose sur des règles. Quiconque prend le sport au sérieux sait qu’il a besoin de règles qui ne sont pas toujours faciles à suivre – et c’est précisément ce qui en fait des règles.  1 Les Jeux Olympiques réunissent des athlètes du monde entier.  Et celles-ci existent à tous les niveaux, des sports individuels aux sports d’équipe. Elles ont été créées pour éviter les blessures, quelles qu’elles soient, y compris morales. Dès lors, le sport est le contraire de la guerre. Il s’agit d’une confrontation et donc aussi de vainqueurs et de vaincus, mais sans blessures, et à fortiori sans mort. Le perdant félicite le gagnant, souvent avec l’espoir d’être le vainqueur de la prochaine rencontre ou en comprenant qu’il reste le perdant, qu’il est plus faible. La guerre, en revanche, consiste à empêcher de telles comparaisons, et donc à détruire. Même si certains la mènent ou pensent la mener pour préserver la culture, elle reste destructrice. Les conflits éclatent pour d'autres raisons: non pour se livrer à une comparaison culturelle, mais pour détruire l’autre. Nous savons aujourd’hui que les guerres font rage pour des raisons politiques et économiques; et nous savons aussi qu’il est difficile de déterminer de manière claire et précise les raisons pouvant justifier une guerre. C’est pourquoi le sport a ou devrait avoir pour fonction de porter un coup d’arrêt à la guerre de manière durable et devrait incarner ce rôle. Le sport a une fonction de maintien de la paix, et de nombreux intérêts devraient être subordonnés à cette mission. Les athlètes devraient être visibles pour préserver leur profession et garantir la paix. La guerre met fin au sport, pas de façon immédiate pour tout le monde, mais tôt ou tard pour tous. Exclure les athlètes des compétitions internationales ou d’événements similaires n’est rien d’autre que faire la guerre par d’autres moyens et n’est donc pas une option pour la paix. La participation de tous les athlètes aux compétitions internationales devrait toujours être le principe qui prévaut, ce qui signifie que mettre fin à la guerre est plus important qu’exclure des athlètes des compétitions. Une utopie certes, mais une belle utopie porteuse d’avenir. Même s’il semble logique de suspendre des compétitions internationales les sportifs issus de pays prétendument ou réellement impliqués dans une guerre injustifiée, il s’agit en réalité d’une violation du devoir des Fédérations Internationales, dont la mission est de veiller à ce que tous les athlètes du monde puissent participer. On pourrait éventuellement exclure des officiels, mais  là aussi avec discernement. Dans ce domaine également, il faudrait utiliser la fonction politico-culturelle ou plutôt anthropologique du sport. Il serait opportun que l’ensemble du monde du sport se mette d’accord pour annuler tous les championnats internationaux tant qu’une guerre sévit quelque part dans le monde – ce serait une arme contre toutes les guerres[!] Pour quiconque recherche la comparaison sportive, il faudrait pouvoir résister à toutes les tentations belliqueuses et, lorsqu’elles se présentent, tenter d’y mettre un terme. Faire appel au monde du sport dans ce but est le diktat du moment. Mais ceux qui utilisent le sport pour creuser les fractures, par exemple en excluant des athlètes des compétitions internationales, vont à l’encontre du bon sens. ■  Karl-Friedrich Wessel a obtenu son doctorat en 1968 en présentant une étude sur le réalisme critique, et a obtenu son titre de professeur en 1975 avec un travail sur la philosophie et la pédagogie. En 1977 il a été nommé à la chaire pour les problèmes philosophiques des sciences naturelles à l’Université Humboldt de Berlin, en Allemagne. De 1990 à 2000, il a fondé et dirigé l’Institut interdisciplinaire de philosophie des sciences et d’ontogénétique humaine. Actuellement, il dirige un projet sur l’ontogénétique humaine à l’Université Humboldt et préside l’Institut d’ontogénétique humaine."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 14-title\" style=\"top:213px;left:50px\" src=\"/120/static/_content/14-title-1.png\"/>\n        <img class=\"halfScale 14-sub\" style=\"top:374px;left:68px\" src=\"/120/static/_content/14-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:209px;left:44px;width:572px;height:121px;\"><a href=\"https://olympics.com/fr/olympic-games/paris-1924\" target=\"_blank\"></a></div>\n\n        <a href=\"https://www.youtube.com/watch?v=IIhV47I5pC0\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:52px;top:503px\" src=\"/120/static/_content/white-play.png\"/>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.fromTo(cOf(\"14-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"14-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1700)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "parIs 1924 hÈrItage de parIs 1900 ou prÈlude ‡ parIs 2024?"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "THIERRY TERRET, ANCIEN DÉLÉGUÉ MINISTÉRIEL AUX JEUX OLYMPIQUES ET PARALYMPIQUES DE PARIS 2024, NOUS RAMÈNE UN SIÈCLE EN ARRIÈRE, LORSQUE L’ÉDITION DE PARIS 1924 MARQUAIT UN TOURNANT DANS L’HISTOIRE DES JEUX ET POSAIT LES BASES DE TRADITIONS QUI PERDURENT JUSQU’À NOS JOURS.  Helen Wills (à gauche) fut l’une des vedettes de Paris 1924, remportant deux médailles d’or en tennis."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <img \n          class=\"abs halfScaleC halfpulse animatedpulse pointer\" \n          style=\"top:479px; left:122px;\"\n          onclick=\"pg16_gallery(0)\" \n          src=\"/120/static/_content/white-camera.png\"\n        />\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  L  e 5 septembre 1924, Pierre de Coubertin publie dans la Revue de Genève un long bilan sur les Jeux qui se sont achevés quelques semaines plus tôt: «Un immense effort d’organisation technique accompli à Paris par un groupe de sportifs compétents et désintéressés – cet effort sans cesse contrarié par les deux personnages dont le temps présent favorise l’ingérence en tous domaines, à savoir le bureaucrate et le politicien – un effort simultané de tous les sportifs de l’univers pour surmonter les difficultés économiques et participer malgré tout aux Jeux de Paris – enﬁn une incompréhension d’ensemble et de multiples malentendus de détail entretenus par cette grande défaillante de la civilisation moderne, la presse… Voilà à vol d’oiseau le résumé des impressions que laisse la  célébration des Jeux de la VIIIe Olympiade». La tonalité nostalgique du texte pourrait suggérer que, trois décennies plus tôt, les tensions n’existaient pas et que les premiers Jeux modernes avaient pu s’affranchir des considérations non sportives. Cela est évidemment faux, mais l’héritage des premiers Jeux n’est pas forcément là où on l’attend. Lors du congrès de la Sorbonne, tenu entre le 16 et 23 juin 1894, les participants ont acté la rénovation des Jeux Olympiques proposée par Coubertin, arrêté leurs grands principes et leur programme, et déterminé la localisation de leurs deux premières éditions, respectivement à Athènes en 1896 et à Paris en 1900. La première expérience des Jeux de Paris est évidemment présente à l’esprit du rénovateur des Jeux lorsque, près de vingt ans plus tard, il défend avec succès la candidature  de la capitale française devant les membres du CIO, réunis en session à Lausanne le 21 juin 1921. Sans doute espérait-il alors que les frustrations de l’organisation de 1900 ne se reproduiraient pas. Il avait en effet dû renoncer à une grande partie de ses attentes, face à des pouvoirs politiques ignorant à peu près tout du sport et, surtout, avec l’obligation de fondre le programme olympique dans l’Exposition universelle où il était bien difficile de distinguer les épreuves proprement olympiques, fortes d’un millier de participants venus de 24 nations*, des multiples concours et démonstrations mis en scène par les organisateurs de l’Expo et comptant, eux, près de 58 000 participants de 30 nations. Il avait également dû accepter que certaines épreuves soient ouvertes à des athlètes professionnels et à des femmes."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  17  Numéro 120  La construction du premier village olympique de l’histoire olympique caractérise aussi les Jeux de 1924.  Les Jeux de 1900, étalés sur plus de 5 mois et répartis sur toute la région parisienne, noyés dans l’Exposition universelle et peu visibles dans la presse, n’ont ﬁnalement guère proﬁté à la capitale française, qui n’a alors pas cherché à valoriser l’événement et encore moins à en faire le socle d’un quelconque héritage, si l’on fait abstraction de la construction du «stade vélodrome» de Vincennes. En 1924, les enseignements de 1900 sont donc davantage à analyser en termes de rupture que de continuité. Avec le douloureux souvenir des tranchées, Paris veut plutôt étaler ses ambitions aux yeux du monde pour d’autres raisons qu’à la Belle Époque. Alors que les autorités politiques ne voyaient là qu’une initiative privée dépourvue de véritable intérêt, le gain d’une médaille justiﬁe désormais la détermination du gouvernement français à accueillir les Jeux Olympiques de 1924. Dans ce contexte, les Jeux ont ﬁnalement lieu entre le 4 mai et le 27 juillet 1924. La cérémonie d’ouverture – elle n’existait pas en 1900 – se déroule en présence des plus hautes personnalités de l’État là où, 24 ans plus tôt, la présence des élus se limitait à valoriser l’Exposition universelle. Ce calendrier étendu n’est d’ailleurs pas la moindre des caractéristiques des Jeux de la VIIIe Olympiade. Si l’histoire a en effet retenu qu’ils se déroulent à Paris, ce sont en réalité près d’une vingtaine de sites qui accueillent les épreuves, dont trois seulement dans la capitale française (le vélodrome d’hiver, le stade Bergeyre et la piscine des Tourelles), une douzaine dans sa grande banlieue (Colombes, Argenteuil, Versailles, Meudon, Saint-Cloud, Bagatelle, Auteuil, Billancourt, Issy-les-Moulineaux, Clichy, Vincennes) et plusieurs à distance de  1 Les Jeux de 1900 à Paris se sont déroulés sur plus de 5 mois. 2 Environ 1 000 athlètes, issus de 24 nations, ont participé aux Jeux de 1900.  2"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "18  Dossier: Paris 1924  Paris: Meulan, Le Havre, Châlons-sur-Marne et Reims). Un choix qui n’est ﬁnalement pas très éloigné de celui de 1900! 3 089 athlètes – dont 135 femmes – provenant de 45 pays s’affrontent dans une vingtaine de sports représentant plus de 120 épreuves†. Quant aux infrastructures, notamment celles destinées à assurer un héritage tangible, les organisateurs optent en grande partie pour une adaptation de l’existant, abandonnant au passage l’hypothèse de la construction d’un stade au cœur de Paris. Dans la banlieue de Colombes, un stade privé, alors loué par le Racing Club de France, est agrandi pour l’occasion aﬁn de recevoir les épreuves les plus prestigieuses et les cérémonies, à la suite d’arbitrages politiques où la concurrence urbaine entre les Jeux de 1924 et l’Exposition universelle qui doit se tenir un an plus tard n’est pas sans rappeler les discussions de 1900. La seule infrastructure héritée des Jeux de 1924 et localisée dans la ville de Paris demeure ﬁnalement la piscine des Tourelles, dont la construction est décidée moins d’un an avant l’ouverture des Jeux. Ce «stade nautique», présenté comme l’un des plus prestigieux du monde, fait évidemment oublier les épreuves de 1900 nagées dans la Seine, malgré des dysfonctionnements techniques dont le coût pèsera longtemps dans le budget de la ville. La construction du premier village olympique de l’histoire olympique caractérise  2  1  1  aussi les Jeux Olympiques de 1924. Composé de petits chalets préfabriqués, en bois, il est mis en place spéciﬁquement pour les Jeux et démonté dès la ﬁn de l’événement. Si aucune animation n’y est prévue, ce village provisoire dispose pourtant déjà de services pour les délégations – coiffeur, kiosque à journaux, poste, blanchisserie, restaurant – que l’on retrouve cent ans plus tard dans le projet de Paris 2024. Avec le village olympique comme pour d’autres décisions, les organisateurs des Jeux de 1924 ont souhaité placer l’innovation au centre de toutes leurs actions, en faisant ainsi écho à l’image que la ville de Paris, par tradition, se donne historiquement d’ellemême. De l’architecture du stade de Colombes à l’utilisation du téléphone et de l’électricité, les surprises sont donc nombreuses. Elles concernent le protocole, avec l’instauration"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "19  la place des femmes. Bien que les Jeux de Paris soient les derniers où les femmes ne peuvent participer aux épreuves d’athlétisme, leur présence en 1924 en tennis, en escrime et en natation ainsi que, de manière moins visible, dans d’autres épreuves (yachting, gymnastique artistique) devient signiﬁcative à une époque où le monde du sport les rejette toujours fortement. Mais certaines innovations cachent aussi des concessions. Lors du congrès de Lausanne, tenu entre le 2 et le 7 juin 1921 en même temps que sa session annuelle, le CIO discute notamment la question des relations avec les Fédérations Internationales et avec les Comités Nationaux Olympiques. Les équilibres étaient jusqu’à présent précaires et mouvants au gré des Jeux et des sessions. Coubertin, qui s’inquiète plus particulièrement du risque de mainmise des 19 Fédérations Internationales sur le Mouvement olympique, parvient à empêcher la création d’une «Fédération des Fédérations Internationales», mais doit accepter celle d’un bureau permanent, à l’initiative de l’Union Cycliste Internationale. Les tensions entre les deux autorités se retrouvent plus particulièrement dans deux dossiers que les organisateurs parisiens auront dès lors à gérer pour 1924. Le premier point porte sur l’amateurisme à un moment où la professionnalisation croissante du sport, notamment du football,  des cérémonies d’ouverture et de clôture et la consolidation du serment des athlètes apparu à Anvers 4 ans plus tôt. Elles touchent aussi les règlements et les techniques. L’invention des lignes d’eau dans les épreuves de natation est par exemple à mettre au crédit des Jeux de Paris. Elles peuvent être institutionnelles quand Coubertin, craignant que les tensions nationalistes ne dégradent l’image des Jeux, créé un «jury d’honneur», dont la postérité ne dépassera pas quelques années. L’innovation sociale, quant à elle, est relative mais substantielle, si l’on considère notamment  1 La piscine des Tourelles, site de Paris 1924, sera un site d’entraînement pour les athlètes des Jeux 2024. 2 Les Jeux de 1924 ont accueilli le premier village olympique, avec bureau de poste et blanchisserie. 3 Pour la première fois de l’histoire olympique, les femmes ont concouru en escrime en 1924.  3"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n      <a href=\"https://www.youtube.com/watch?v=D6RK0M6-GUg\" target=\"_blank\">\n        <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:394px;top:443px\" src=\"/120/static/_content/white-play.png\"/>\n      </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "20  Dossier: Paris 1924  Paris 2024 renoue avec son passé olympique en organisant des Jeux dispersés dans l’espace.  1  devient incompatible avec le maintien des valeurs héritées du XIXe siècle auxquelles s’accrochent les membres du CIO. Il est ﬁnalement décidé que la qualité d’amateur pour les Jeux sera ﬁxée par chaque Fédération Internationale de même que, pour la première fois officiellement, des règlements sportifs. Le second point concerne le programme olympique que le CIO souhaiterait réduire au détriment du cyclisme, du football, du tennis, de la voile et du tir, alors que les Fédérations Internationales demandent au contraire son élargissement. En déﬁnitive, seuls le hockey sur gazon, le golf et le tir à l’arc sont supprimés, mais des modiﬁcations substantielles touchent plusieurs épreuves: suppression de la voltige équestre et du lancement du poids de 25,4 kg, remplacement du 300 m brasse dames par un 400 m, augmentation du nombre de catégories de 5 à 6 en lutte gréco-romaine, de 5 à 7 en lutte libre et de 6 à 8 en boxe, etc. Le programme olympique de Paris est donc  original. D’abord parce que diverses démonstrations sont ajoutées en basket, volley, baseball, cage-ball, gymnastique artistique, pelote basque, canoë canadien, boxe française, canne et autres jeux scouts‡, dont certaines connaîtront des lendemains heureux. Mais surtout parce que les Jeux de 1924, entre les arbitrages du CIO et les demandes des organisateurs, ne parviennent pas totalement à trancher entre les caractéristiques du monde sportif de l’avant-guerre et celles de la modernité. Le rugby et le football vivent respectivement leur dernière et avant-dernière aventure olympique (dans leurs formats de l’époque). Les résistances de la GrandeBretagne pour l’un, les sirènes d’une Coupe du monde qui se proﬁle pour l’autre sur fond de  1 Le gymnaste suisse Jean Gutweniger en route pour la médaille d’argent au cheval d’arçon.  débats sur l’amateurisme, auront raison des ambitions développées par les organisateurs. À Paris, le succès est aussi au rendez-vous pour le cyclisme olympique malgré la concurrence du Tour de France. En gymnastique, le tournoi olympique doit s’analyser comme l’ultime épisode de la lutte qui oppose les tenants d’une gymnastique éducative et d’une gymnastique sportive. L’escrime, pour sa part, met aux prises davantage que des champions: les tireurs italiens et français, notamment, sont aussi porteurs de l’héritage des écoles d’escrime qui opposent les deux nations depuis trois siècles. Toutes les valeurs traditionnelles de la force et de la virilité se retrouvent dans les tournois de lutte et de poids et haltères qui, il faut en convenir, n’attirent déjà quasiment aucun spectateur. C’est également en raison de son poids dans la tradition que la boxe, après avoir disparu du programme olympique, réapparaît à Anvers puis à Paris, mais sa version amateure y est bien modeste face aux combats des professionnels qui, de l’autre côté de l’Atlantique, font rêver le milieu des rings et, au-delà, toute la société américaine. De même, le lawn tennis peut-il vraiment lutter, à Paris, contre la concurrence de la Coupe Davis? Sans doute pas, puisqu’il vit alors son ultime intégration au programme des Jeux jusqu’en 1988. Quant au polo, ce sport cher à Coubertin, il vit son crépuscule olympique dans un tournoi d’élites plutôt conﬁdentiel. Pour la troisième fois de l’histoire olympique après Stockholm 1912 et Anvers 1920, les Jeux incluent également un concours d’art en peinture, architecture, sculpture, littérature et musique. Une programmation logique pour Paris et son bouillonnement artistique, ses excentricités vestimentaires qui dévoilent autant les aspirations de l’émancipation féminine que les nouveaux chantiers de la mode, ses rencontres mondaines et ses hauts-lieux de la musique et du divertissement. Paris est alors le repère d’un Jean Cocteau et"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Team Visa. Supporting athletes more than 20 years.  Visa is a proud sponsor of the Olympic and Paralympic Games.  PV Sindhu India, Badminton Team Visa"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:608px;left:616px;height:11px;width:51px;\">\n          <a href=\"https://www.youtube.com/watch?v=B0wi4Qe3Iu8\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:620px;left:475px;height:11px;width:95px;\">\n          <a href=\"https://www.youtube.com/watch?v=B0wi4Qe3Iu8\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "1  d’une Colette, d’un Paul Morant et d’un Jean Giraudoux. Le mouvement dada y survit encore avec Tristan Tzara et les grandes ﬁgures du surréalisme y sont déjà bien visibles, d’André Breton à Robert Desnos ou de Louis Aragon à Paul Éluard. En 1924, les Jeux Olympiques font peut-être rêver le monde entier, mais la Ville lumière doit davantage son aura à l’excitation de sa vie culturelle. Aux Jeux, du reste, ni le concours d’architecture, ni celui de musique n’atteignent un niveau suffisant pour justiﬁer la désignation d’un vainqueur. À la différence des Jeux de 1900, les organisateurs des Jeux de 1924 ont particulièrement soigné la promotion de la manifestation olympique. Pour la première fois, celle-ci est d’ailleurs retransmise partiellement en direct à la radio, le journaliste Edmond Dehorter n’hésitant pas à suivre les compétitions depuis un ballon dirigeable. Plus généralement, 724 journalistes sont accrédités par le Comité Olympique Français, qui distribue des milliers de brochures et assure aussi une promotion très active de la manifestation olympique, par exemple avec la diffusion de trois millions de timbres et de 20 000 exemplaires de deux affiches des Jeux réalisées par Orsi et Jean Droit. En 1900, cette volonté de communiquer largement et en amont sur l’événement olympique était faible;  elle connaît en 1924 une ampleur qui annonce l’accélération de la médiatisation des Jeux que Paris 2024 a poussée encore plus loin. Cette promotion a-t-elle eu des effets? Rien n’est moins sûr. Certes, au moment du bilan, Frantz Reichel, le secrétaire général des Jeux de Paris, estime que ceux-ci ont été un véritable succès en attirant près d’un demimillion de spectateurs cumulés sur l’ensemble des épreuves. En réalité, si l’on fait abstraction des deux sports les plus suivis – le football et l’athlétisme – le nombre de spectateurs payants atteint difficilement 175 000, chiffre relativement modeste si l’on prend en considération le nombre d’épreuves organisées et les 5 millions de tickets édités! Un bilan également à évaluer à l’aune des Jeux de 1900 pour lesquels on ignore toujours le nombre précis de spectateurs qui ont assisté aux épreuves olympiques parmi les quelque 50 millions de visiteurs de l’Exposition universelle. Sur le plan sportif, les athlètes américains étaient venus pour briller: ils remportent effectivement 45 médailles d’or, très loin devant la Finlande (14), la France (14) et la Grande-Bretagne (9). À l’exception de l’Allemagne, non invitée, ce classement conﬁrme globalement les principales hiérarchies sportives du moment. Cette stabilité ressort aussi de la comparaison avec  les Jeux de 1900, où la France l’avait emporté devant les États-Unis et la Grande-Bretagne. Mais en 1900, le sport international n’avait pas encore de véritable champion alors qu’en 1924, 1 des héros sont nés ou ont conﬁrmé leur stature. L’histoire retient ainsi les noms du quintuple champion Paavo Nurmi, chef de ﬁle des «Finlandais volants», du sprinter britannique Harold Abraham, immortalisé en 1981 dans Les Charriots de feu, de l’Américain et futur Tarzan d’Hollywood Johnny Weissmuller, du Français Charles Rigoulot, «l’homme le plus fort du monde», de l’équipe de football d’Uruguay, du prodige yougoslave Leon Štukelj en gymnastique, de la joueuse de tennis américaine Helen Wills et de bien d’autres encore. À l’occasion des Jeux de 1924, les bases structurelles et politiques de l’Olympisme sont rénovées (commission exécutive, Charte, etc.), les grands rituels sont, à quelques exceptions près, stabilisés, et les Jeux Olympiques eux-mêmes atteignent un niveau d’organisation et de légitimité qui n’a plus grand-chose à voir avec leurs premières éditions. Toutefois, il est incontestable que le congrès de Prague, du 26 mai au 4 juin 1925, transforme en profondeur le fonctionnement du CIO et l’organisation des Jeux suivants. Le remplacement de Coubertin par Baillet-Latour,"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  23  Numéro 120  le nouveau poids de la commission exécutive, les nouvelles relations entre le CIO et les Fédérations Internationales, la déﬁnition de l’amateurisme, le retour de l’Allemagne, l’extension du programme féminin, la reconnaissance des Jeux Olympiques d’hiver sont autant de points tranchés après Paris, qui donnent aux Olympiades suivantes un cadre partiellement différent du précédent. Les Jeux de 1924 marquent donc moins une révolution qu’une transition. Avec Paris s’achèvent d’une certaine manière les «Jeux de Coubertin». Une nouvelle étape commence, où les Jeux devront relever deux déﬁs majeurs, celui du professionnalisme et celui du nationalisme, le tout dans un environnement sportif concurrentiel, qui se manifeste dans des événements parallèles, qu’il s’agisse des «Olympiades» ouvrières de 1925, des «Jeux Olympiques féminins» d’Alice Milliat en 1922 (voir p.31) ou des Jeux des sourds qui se déroulent à Paris en août 1924. Les uns dénoncent la connivence avec le capitalisme bourgeois, les autres l’injuste domination masculine, les derniers l’insuffisante prise en compte des vulnérabilités, toutes choses sur lesquelles, précisément, Paris 2024 souhaite revenir aujourd’hui avec des Jeux explicitement populaires, paritaires et inclusifs. Tout comme Paris 1924 s’est en partie construit en rupture avec Paris 1900, Paris 2024 souhaite plus généralement limiter sa ﬁliation avec l’expérience de la capitale française cent ans plus tôt, en valorisant par exemple des problématiques propres au XXIe siècle comme le souci de transition écologique, l’ambition d’un héritage matériel et immatériel ou la prise en compte des questions sécuritaires. Pourtant, les points communs sont plus nombreux qu’il n’y paraît: volonté d’utiliser les infrastructures sportives existantes dans un contexte de saturation urbaine, quitte à s’appuyer pour certaines épreuves à nouveau sur le stade de Colombes et la piscine des Tourelles rebaptisée entretemps, souci omniprésent de l’innovation, importance de la communication, même si la radio a désormais moins de poids que la télévision et les réseaux sociaux, arbitrages  1 Le stade de Colombes, rebaptisé stade Yve-du-Manoir, accueillera le hockey sur gazon 100 ans après. 2 Paris 2024 veut valoriser des problématiques du XXIe siècle comme la transition écologique et l’héritage.  difficiles sur le programme des Jeux, ou encore ambition d’associer le sport et la culture. Plus surprenant, le Paris de 2024, bien que recentré sur deux semaines d’épreuves, renoue avec son passé olympique en organisant des Jeux dispersés dans l’espace, qui s’étirent jusqu’aux vagues de Teahupo’o en Polynésie française, le tout dans un contexte géopolitique de guerre et de crise économique, un siècle après des Jeux marqués par les conséquences de la Grande Guerre. ■  Notes de fin d’article * Sur ce sujet, les historiens olympiques citent des chiffres allant de 28 à 30 nations.  Thierry Terret fut professeur d’histoire du sport à l’Université de Lyon, en France, avant d’embrasser une carrière de haut-fonctionnaire successivement comme recteur dans plusieurs régions françaises et délégué ministériel aux Jeux Olympiques et Paralympiques de 2024. Ancien président de la Société internationale d’histoire du sport et de l’éducation physique (ISHPES) et de la Société française d’histoire du sport, il a écrit ou édité près de 75 livres et 350 articles et chapitres sur l’histoire du sport, avec une attention particulière sur les questions de genre, de politique et de transfert culturel.  ‡ Plusieurs de ces activités ont été regroupées dans une manifestation consacrée aux jeux et sports pour enfants, «Les Jeux de l’enfance» dans le programme officiel des Jeux ou «Jeux pour tous» par les médias. Voir: T. Terret, «Jeux de l’enfance et démonstrations», in T. Terret (dir.), Les paris des Jeux olympiques de 1924, volume 4: Les paris culturels, Biarritz, Atlantica, 2008, pp. 1145-1170.  2  † Ces chiffres sont sujets à discussion. Le rapport officiel des Jeux recense 19 «sports et jeux», auxquels s’ajoutent les concours artistiques et les sports d’hiver. Les épreuves sont numérotées de 1 (athlétisme 100 m) à 126 (course à la voile de 8 m); la numérotation s’arrête ensuite pour les concours artistiques avant de reprendre pour les sports d’hiver (de 127 à 142), bien que ceux-ci ne fassent pas officiellement partie du programme olympique."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 24-title-1\" style=\"top:138px;left:44px\" src=\"/120/static/_content/24-title-1.png\"/>\n        <img class=\"halfScale 24-title-2\" style=\"top:170px;left:43px\" src=\"/120/static/_content/24-title-2.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:534px;left:145px;height:13px;width:51px;\">\n          <a href=\"https://olympics.com/cio/pierre-de-coubertin\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLinkThree\" style=\"top:551px;left:64px;height:13px;width:95px;\">\n          <a href=\"https://olympics.com/cio/pierre-de-coubertin\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"24-title-2\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          }, 1900)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "pIerre de coubertIn et parIs 1924:  une hIstoIre de cúur LES JEUX DE LA VIIIE OLYMPIADE ONT INCARNÉ LA VISION DE PIERRE DE COUBERTIN POUR LE PLUS GRAND SPECTACLE SPORTIF DU MONDE, DONT CERTAINES IDÉES RESTENT PERTINENTES ENCORE AUJOURD’HUI. PAR GEORGE HIRTHLER  1"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  25  Numéro 120  L  es Jeux Olympiques de Paris 1924 furent le chant du cygne de Pierre de Coubertin. Maître de l’art théâtral, il avait préparé la scène pour son départ des années auparavant. Lorsqu’il avait annoncé sa retraite en 1921, dans une lettre poignante envoyée à ses collègues du CIO, il leur avait demandé qu’ils lui accordent un dernier vœu, «qu’une faveur exceptionnelle soit faite à [sa] ville natale, Paris» en lui accordant l’édition 1924, tout en nommant Amsterdam ville hôte des Jeux de 1928. Il savait que le CIO ne lui refuserait pas de célébrer l’apogée de son œuvre olympique historique dans la capitale du pays pour lequel il avait proclamé sa «passion folle» à l’âge de 12 ans. S’il aimait le Mouvement olympique, qu’il avait lancé à la Sorbonne 30 ans plus tôt, Coubertin vouait un amour encore plus grand à la France. Il écrivait continuellement son  1 Pierre de Coubertin tenait à ce que ses derniers Jeux en tant que président du CIO se déroulent à Paris. 2 Coubertin (au centre) remet des prix lors de la cérémonie de clôture de Paris 1924.  2  histoire, cherchait à promouvoir sa stature internationale et intégrait sa langue et ses valeurs au cœur du Mouvement olympique. En outre, il admirait par-dessus tout le succès de la IIIe République, au service de laquelle il a mis très jeune son intelligence et ses talents aﬁn de contribuer à la réforme de l’éducation nationale française dans les années 1880. En fait, à l’origine, sa motivation pour restaurer les Jeux Olympiques modernes était ancrée dans l’espoir que cet événement puisse couronner de gloire son pays natal. Les fouilles allemandes entreprises dans la cité antique d’Olympie de 1874 à 1880 l’ont d’ailleurs mené à écrire en 1909: «Rien dans l’histoire ancienne ne m’avait rendu plus songeur qu’Olympie. Cette cité de rêve (…) dressait sans cesse devant ma pensée d’adolescent ses colonnades et ses portiques. L’Allemagne avait exhumé ce qui restait d’Olympie; pourquoi la France ne réussirait-elle pas à en reconstituer les splendeurs?» En 1915, il apportait un nouveau gage d’amour à sa patrie en rejoignant l’armée française pour défendre sa nation lors de la Grande Guerre, mettant entre parenthèses les devoirs de sa présidence olympique après avoir fait déménager le siège du CIO de Paris pour la sécurité paisible offerte par Lausanne, protégée par la neutralité suisse. À 52 ans,  il était trop âgé pour aller au front: il a donc travaillé pour le Ministère de la guerre, au Département de la propagande, et a voyagé dans les régions pour donner des discours visant à stimuler l’esprit de corps français. Bien qu’il ait lancé un mouvement destiné à promouvoir la paix entre les nations, Coubertin ne pouvait se résoudre à être paciﬁste lorsque le sort de la France était engagé. De retour à Paris en juin 1924 pour mettre la touche ﬁnale à sa carrière olympique, émotions et pensées se bousculaient chez lui à l’aube de clore ce chapitre de sa vie. Patriote jusque dans sa ﬁerté, il estimait que Paris – la capitale mondiale de la culture – apposerait un sceau d’immortalité sur le travail de toute une vie et assurerait une place permanente au calendrier international pour son mouvement mondial promouvant l’amitié et la paix à travers le sport. Après la Grande Guerre, Coubertin avait offert une nouvelle résurrection aux Jeux Olympiques, à Anvers en 1920, une édition aux accents militaires par nécessité, suite aux ravages du conﬂit. Il espérait désormais que Paris pourrait proposer une célébration de l’élite de l’athlétisme et de la culture qui surpasserait les six précédentes Olympiades et concrétiserait enﬁn sa vision extraordinaire. Tout s’annonçait pour le mieux: la cérémonie d’ouverture était programmée"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "26  Dossier: Pierre de Coubertin  le 5 juillet et les équipes de 45 nations s’installaient déjà dans le nouveau village olympique, une innovation française symbolisant l’unité mondiale que les Jeux cherchaient à promouvoir. Une affluence record était prévue, avec 3 089 athlètes, dont 135 femmes. Mais avant que les épreuves ne débutent, il convenait de célébrer dignement le 30e anniversaire de la création des Jeux Olympiques modernes, à l’endroit même où ils étaient nés. Dans la cour d’honneur de la Sorbonne et au milieu d’une foule dense, Coubertin et ses collègues du CIO ont accueilli le président de la République française fraîchement élu, Gaston Doumergue. En signe de gratitude envers la ville hôte et le pays, Coubertin lui a offert un écrin contenant deux médailles d’or: sur la première, gravée 30 ans plus tôt, ﬁgurait l’inscription «Le Congrès International de Paris proclame le rétablissement des Jeux Olympiques, 23 juin 1894». La seconde commémorait l’occasion: «Les nations assemblées célèbrent le trentième anniversaire de l’Olympisme rénové, 23 juin 1924». Ce soir-là, le président français a donné un dîner au Palais de l’Élysée pour Coubertin et le CIO, durant lequel il a porté un toast et exprimé son admiration officielle pour le Mouvement olympique. Quelques jours plus tard, au cours d’une autre réception organisée à l’Hôtel de Ville par le maire et le préfet de la Seine, Coubertin a exprimé sa gratitude. Remerciant Paris pour avoir hissé les Jeux Olympiques vers de nouveaux sommets, il a toutefois rappelé qu’indépendamment de ce qui se produirait lors des jours qui suivraient, son œuvre globale se poursuivrait: «L’océan du sport semble vivre des ﬂuctuations, tout comme l’océan marin», déclarait-il, mais «le sport est devenu international et nous pouvons donc espérer que ce mouvement ne s’arrêtera pas, car s’il lui arrivait de ﬂéchir en un point, il serait revigoré en un autre.» Avant de conclure son discours par une proclamation puissante: «Longue vie à Paris!» Une fois les Jeux ouverts, la compétition s’est distinguée par son excellence. Johnny Weissmuller, le nageur américain qui brillerait à Hollywood en incarnant Tarzan, établissait un record olympique sur 100 mètres en battant la marque de l’Hawaïen Duke Kahanamoku, qui avait remporté l’or lors des deux précédentes éditions. Paris mettait également à l’honneur  1  Paavo Nurmi, le coureur qui remporterait neuf médailles d’or olympiques dans sa carrière, ainsi que les coureurs Eric Liddell et Harold Abrahams, immortalisés dans Les Chariots de feu. Bien qu’il ait exprimé son opposition à la participation des femmes aux Jeux Olympiques, le baron ne l’a jamais bloquée et le nombre d’athlètes féminines participant aux Jeux a été multiplié par six sous sa présidence. L’édition 1924 a même marqué un nouveau précédent dans ce domaine, ce que Coubertin a semblé célébrer en assistant au tournoi de tennis féminin. Accompagné de son neveu Christian de Navacelle et de sa nièce Marie-Marcelle de Coubertin, il a vu la championne française Julie Vlasto s’incliner en ﬁnale face à la sensation américaine Helen Wills. Âgée de 18 ans, la jeune femme remporterait entre autres huit titres à Wimbledon et deviendrait la première sportive américaine à atteindre une renommée internationale. Si Coubertin a eu maille à partir avec certaines autorités sportives françaises avant les Jeux, il ne fait aucun doute que Paris 1924 a couronné le «rénovateur», en concluant son ère dans sa ville de naissance avec le plus beau festival olympique jamais organisé. L’année suivante, lors du Congrès du CIO à Prague, en Tchécoslovaquie, le baron monterait sur le podium de l’Hôtel de Ville et demanderait  à ses collègues de poursuivre son œuvre après son départ. Lors de ces adieux, Coubertin a exprimé sa gratitude, tout en adressant une série de mises en garde. Il a exhorté ses collègues à protéger plusieurs principes, dont l’universalité des Jeux Olympiques. «Est-il besoin de rappeler qu’ils ne sont la propriété d’aucun pays ni d’aucune race en particulier et qu’ils ne peuvent être monopolisés par des groupements quelconques. Ils sont mondiaux; tous les peuples y doivent être admis sans discussion, de même que tous les sports y doivent être traités sur un pied d’égalité sans souci des ﬂuctuations ou des caprices de l’opinion.» Son message continue de transmettre de nos jours une immédiateté morale qui reﬂète les qualités intemporelles de sa vision olympique, que Paris et la France sont parfaitement indiquées pour célébrer, à l’époque comme aujourd’hui. ■ L’auteur américain George Hirthler a écrit The Idealist, une ﬁction historique sur la vie de Pierre de Coubertin et son époque. Il a reçu la médaille Pierre de Coubertin en 2022.  1 Coubertin a encouragé ses collègues à perpétuer son héritage lors du Congrès du CIO à Prague en 1925."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "         "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 28-title-1\" style=\"top:43px;left:40px\" src=\"/120/static/_content/28-title-1.png\"/>\n        <img class=\"halfScale 28-sub-1\" style=\"top:298px;left:44px\" src=\"/120/static/_content/28-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg28Anim = new TimelineMax();\n          pg28Anim.fromTo(cOf(\"28-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"28-sub-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg28Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "les femmes aux jeux olympIques un long chemIn (1896−2024)"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 28,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg29.jpg",
    "zoom": null,
    "content": "\n      <div class=\"addContentLinkThree\" style=\"top:787px;left:336px;height:14px;width:179px;\">\n        <a href=\"https://olympics.com/fr/infos/paris-2024-premiers-jeux-atteindre-parite-genres\" target=\"_blank\"></a>\n      </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Les femmes participent pour la première fois à la natation aux Jeux Olympiques de Stockholm en 1912.  LES JEUX OLYMPIQUES DE PARIS 2024 MARQUERONT UNE ÉTAPE IMPORTANTE DANS LA PARITÉ HOMMES-FEMMES, AVEC UN NOMBRE ÉGAL D’ATHLÈTES MASCULINS ET FÉMININS, MAIS LE CHEMIN POUR Y PARVENIR A ÉTÉ LONG ET SEMÉ D’EMBÛCHES. PAR FLORENCE CARPENTIER"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 29,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg30.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  I  l aura fallu 130 ans pour que les Jeux Olympiques, la grande fête sportive quadriennale et mondiale fondée en 1894 par Pierre de Coubertin, offrent une place égale aux femmes et aux hommes sur le stade. Annoncée officiellement pour les Jeux parisiens de 2024, la parité entre les 10 500 participants était en marche depuis les années 1990. Avant cela, le chemin vers l’admission des femmes dans toutes les épreuves olympiques fut parsemé de résistances et de préjugés sexistes, mais aussi de militantisme et de prises de position courageuses, dans un XXe siècle où les rôles assignés aux hommes et aux femmes dans la société étaient progressivement repensés.  Les premières championnes olympiques: élégance, grâce et beauté Comme la majorité conservatrice de la ﬁn du XIXe siècle, Pierre de Coubertin n’était pas favorable au sport pour les femmes qu’il jugeait trop violent pour elles et moralement indécent pour un public masculin. Son projet d’éducation par le sport s’adressait avant tout aux jeunes hommes, future élite dirigeante des Nations. À l’image de l’allégorie de la Victoire représentée sur l’affiche des premiers Jeux à  Athènes, on limitait la participation des femmes au couronnement des vainqueurs. Pour autant, dès 1896, les femmes se sont enthousiasmées pour la compétition olympique. La presse grecque raconte l’histoire de Stamáta Revíthi, une mère de 30 ans, à qui on refusa l’inscription au marathon. Par ﬁerté probablement, elle réalisa la course le lendemain de l’épreuve officielle. Contre l’avis du fondateur, les premières sportswomen entrèrent à Paris en 1900, sur décision des organisateurs de l’Exposition universelle dans laquelle les épreuves olympiques s’inscrivaient. Les premiers sports à accepter la mixité sont le tennis, le golf et le croquet (1900), le tir à l’arc (1904) et le patinage (1908), loisirs des élites où les femmes sont admises dans le respect des convenances morales et sociales. La joueuse de tennis anglaise Charlotte Cooper est connue pour être la première femme médaillée olympique. Elle est aussi une grande championne de son époque. Mais, les femmes sont surtout présentes dans les à-côtés des Jeux, avec des démonstrations de mouvements gymniques à visées hygiéniques et esthétiques, présentant des méthodes «nationales»  de renforcement des «races». En 1912, à Stockholm, la natation et le plongeon s’ajoutent à la liste des pratiques acceptables pour les femmes qu’on assimile à de belles ondines. Ainsi, avant la Grande Guerre, la participation des femmes aux Jeux est conditionnée à l’élégance, la grâce et la beauté.  Alice Milliat, l’émancipation des femmes par le sport La situation des sportives évolue pendant la guerre. À partir de 1915, une jeune Française militante issue de milieu populaire devient la première dirigeante à encourager la pratique sportive et la compétition pour les femmes au nom de l’égalité des sexes. Alice Milliat est née à Nantes en 1884 dans une famille de petits commerçants. À 20 ans, elle se rend à Londres pour devenir préceptrice dans une famille bourgeoise qui la fait voyager. Elle y découvre aussi avec bonheur le football, le hockey, l’athlétisme et l’aviron, alors qu’elle  1 Alice Milliat (à gauche) a fait partie du comité d’arbitrage des épreuves d’athlétisme à Amsterdam en 1928. 2 La campagne d’Alice Milliat a joué un rôle clé dans l’introduction de l’athlétisme féminin aux Jeux pour la première fois en 1928."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 30,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg31.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  s’était tant ennuyée dans les cours de gymnastique hygiénique à l’école en France. Cette expérience étrangère épanouissante va inspirer le reste de sa vie. Mariée puis veuve, sans enfant, Alice Milliat s’installe à Paris avant la guerre pour trouver du travail comme sténographe-interprète. Elle s’inscrit dans le premier club féminin de la capitale, Fémina sport, fondé en 1912 et en prend la présidence en 1915. S’ensuit alors une métamorphose du club qui s’oriente vers l’entraînement et la compétition dans de nombreux sports, y compris le football, bastion masculin historique. Pour les féministes françaises de l’époque, le sport est «un heureux mouvement qui tend à développer la valeur physique et morale de la femme» et surtout «les sportives font la preuve que, lorsqu’elle cultive ses facultés physiques, la femme cesse d’être “l’enfant malade” sur laquelle on a pleuré tant de larmes de crocodiles»*. Alice Milliat, elle-même, a la plume alerte et un franc-parler certain qui lui permettent de défendre l’égalité des sexes et de dénoncer la «domination masculine» dans les nombreux articles de presse qu’elle publie dans les années 1920 et 1930. Associée à la première fédération nationale féminine sportive fondée  2  31  Numéro 120  par des hommes en 1917, elle en prend la présidence en 1919 et remplace les dirigeants par des femmes: la destinée du sport féminin doit être impérativement, selon elle, entre les mains des sportives. Il faut dire que les dirigeants des fédérations françaises masculines s’en accommodent bien, et l’argument du sport comme outil de renforcement de la «race française», utilisé habilement par Milliat, permet de convaincre les plus conservateurs. C’est ainsi que l’organisation du sport pour les femmes se développe rapidement en France dès la ﬁn de la guerre. Toutefois, les ambitions d’Alice Milliat pour ses sœurs du stade vont au-delà des frontières.  L’athlétisme olympique, une conquête symbolique Le rêve de Milliat est de faire admettre les femmes aux Jeux Olympiques dans le sport le plus emblématique: l’athlétisme. En 1926, elle a*irme avoir essuyé un «refus formel» de la part de Pierre de Coubertin en 1919, «et c’est de là que naquirent les Jeux féminins dont les premiers eurent lieu à Paris en 1922»†. Si nous n’avons aucune trace écrite de cette demande, ni de sa réponse, l’histoire paraît probable. Aux Jeux de 1920 à Anvers, aucune évolution pour  les femmes n’est enregistrée par rapport à l’avant-guerre, une soixantaine de sportives participent aux compétitions, soit 2,4% des concurrents. Un an plus tard, après avoir organisé les premiers échanges internationaux d’athlétisme féminin entre la France, la Belgique, l’Angleterre, la Suisse ou la Tchécoslovaquie, Alice Milliat initie la création d’une Fédération Sportive Féminine Internationale (FSFI) dans le but est de valider les records sportifs, de règlementer les sports pour les femmes et d’organiser les compétitions entre pays, notamment des «Jeux Olympiques féminins» quadriennaux, à l’image de ceux du CIO pour les hommes. La première édition a lieu à Paris, le 20 août 1922, et rassemble 77 sportives de cinq nationalités pour s’a*ronter dans treize épreuves d’athlétisme. L’évènement est un succès sportif mais provoque néanmoins de nombreuses réactions sexistes dans les médias, les milieux médicaux et surtout dans la sphère sportive. En France, comme au sein du CIO, on souhaite désormais que les fédérations masculines reprennent la main sur l’organisation du sport féminin pour en modérer le développement. En 1925, Pierre de Coubertin quitte la présidence du CIO au proﬁt du comte belge"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 31,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg32.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "32  Dossier: Les femmes aux Jeux Olympiques  1  2  Henri de Baillet-Latour. Ce n’est pas un hasard si la FSFI de Milliat décide d’organiser la deuxième édition de ses Jeux à Bruxelles, dans l’espoir d’attirer l’attention, voire la bienveillance, du nouveau président. Après l’abandon des organisatrices belges, la FSFI se tourne vers Göteborg, en Suède, contrée du puissant J. Sigfried Edström, président de l’IAAF et membre de la commission exécutive du CIO. La nouvelle réussite des deuxièmes Jeux (rebaptisés «Jeux mondiaux») décide alors le dirigeant suédois à prendre le contrôle du développement de l’athlétisme féminin. Il milite pour l’admission des femmes dans ce sport aux Jeux d’Amsterdam de 1928, mais dans quelques épreuves seulement, à titre d’expérience, alors qu’Alice Milliat réclamait une participation égale aux hommes. En parallèle et en sous-main, Edström utilise les représentants nationaux de l’IAAF pour faire échouer les fédérations nationales féminines, en particulier en France. Il lui faut une dizaine d’années et le contexte de la crise économique des années 1930 en Europe pour faire capituler Alice  1 Flor-Isava Fonseca a été la première femme membre de la commission exécutive du CIO. 2 Les femmes représentaient 49% des athlètes à Tokyo 2020, les Jeux les plus équilibrés de l’histoire.  Milliat, épuisée par ses combats et la recherche constante de ﬁnancements. En janvier 1935, Edström écrit à son collègue et ami l’Américain Avery Brundage: «Je suppose que vous savez que la Fédération de Mme Milliat nous a causé tant d’ennuis que nous n’avons aucun intérêt à la soutenir. Nous aimerions qu’elle disparaisse de la surface de la terre.»‡ Quelques mois plus tard, la FSFI se saborde malgré quatre éditions de Jeux mondiaux féminins et l’augmentation constante des participantes et des pays affiliés. Alice Milliat se retire de la vie publique et décède en 1957 dans l’anonymat le plus total.  Un long marathon vers l’égalité En 1942, le dirigeant suédois devient président du CIO à la suite du décès de Baillet-Latour, puis laisse sa place en 1952 à Avery Brundage, à la tête pendant vingt ans. Ainsi, pendant ces deux longues présidences, le pourcentage de femmes reste limité, passant de 9,5% en 1948 à 14,6% en 1972. Alors que la place des femmes est même parfois remise en question par certains membres du CIO, au nom de la lutte contre le gigantisme des Jeux, le soutien le plus important vient des Soviétiques, entrés dans la compétition olympique en 1952. Dans le contexte de la Guerre froide, l’URSS mise  sur les épreuves délaissées par les États-Unis, notamment celles féminines, pour remporter le plus grand nombre de médailles. C’est ainsi que les membres communistes du CIO n’ont de cesse de réclamer de nouvelles épreuves pour les femmes. Ils sont peu écoutés, mais à partir de 1972, le nouveau président irlandais Michael Killanin est plus enclin à accepter les sportives, dans un contexte de mutations sociales en faveur de l’égalité des sexes. Mais la route est encore longue. En 1981, le successeur Juan Antonio Samaranch fait coopter les deux premières femmes au sein du CIO, ce qui représente une petite révolution pour l’institution. Les Jeux comptent alors 20% de femmes. C’est la création d’un groupe de travail consultatif «femme et sport» en 1995 qui va réellement accélérer le processus pour atteindre l’égale participation, mais aussi la création d’épreuves féminines dans tous les sports olympiques. Depuis, la politique du CIO en faveur des femmes dans le sport est devenue ambitieuse. Sa position historique d’organisation faitière du sport international lui donne un grand pouvoir d’incitation sur les institutions mondiales et nationales. Si le CIO s’est longtemps opposé aux sportives, il faut convenir qu’aujourd’hui, il réussit là où d’autres sphères culturelles comme les"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 32,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg33.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:730px;left:525px;height:19px;width:146px;\">\n          <a href=\"https://deloitte.com/olympics\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "One Some Many All Together  Together, weíre making an impact. Through our management consulting expertise, weíre helping the IOC to ensure                   "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 33,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg34.jpg",
    "zoom": null,
    "content": "\n\n        <div class=\"abs noOverflow\" style=\"top: 479px;left: 263px;height: 366px;width: 200px;\">\n          <img class=\"halfScale 34-bar-1\" style=\"top:350px;left:2px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-2\" style=\"top:333px;left:30px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-3\" style=\"top:296px;left:58px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-4\" style=\"top:214px;left:87px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-5\" style=\"top:116px;left:115px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-6\" style=\"top:43px;left:144px\" src=\"/120/static/_content/34-bar-1.png\"/>\n          <img class=\"halfScale 34-bar-7\" style=\"top:1px;left:172px\" src=\"/120/static/_content/34-bar-1.png\"/>\n        </div>\n\n        <img class=\"halfScale 34-text-1\" style=\"top: 671px;left: 270px;\" src=\"/120/static/_content/34-text-1.png\"/>\n        <img class=\"halfScale 34-text-2\" style=\"top: 736px;left: 303px;\" src=\"/120/static/_content/34-text-2.png\"/>\n        <img class=\"halfScale 34-text-3\" style=\"top: 691px;left: 332px;\" src=\"/120/static/_content/34-text-3.png\"/>\n        <img class=\"halfScale 34-text-4\" style=\"top: 754px;left: 359px;\" src=\"/120/static/_content/34-text-4.png\"/>\n        <img class=\"halfScale 34-text-5\" style=\"top: 766px;left: 388px;\" src=\"/120/static/_content/34-text-5.png\"/>\n        <img class=\"halfScale 34-text-6\" style=\"top: 617px;left: 411px;\" src=\"/120/static/_content/34-text-6.png\"/>\n        <img class=\"halfScale 34-text-7\" style=\"top: 623px;left: 440px;\" src=\"/120/static/_content/34-text-7.png\"/>\n\n        <div class=\"abs noOverflow\" style=\"top: 479px;left: 490px;height: 366px;width: 200px;\">\n        <img class=\"halfScale 34-bar-8\" style=\"top:334px;left:2px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-9\" style=\"top:251px;left:30px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-10\" style=\"top:209px;left:58px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-11\" style=\"top:69px;left:87px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-12\" style=\"top:39px;left:116px\" src=\"/120/static/_content/34-bar-2.png\"/>\n        <img class=\"halfScale 34-bar-13\" style=\"top:23px;left:144px\" src=\"/120/static/_content/34-bar-2.png\"/>\n      </div>\n\n      <img class=\"halfScale 34-text-8\" style=\"top: 721px;left: 500px;\" src=\"/120/static/_content/34-text-8.png\"/>\n      <img class=\"halfScale 34-text-9\" style=\"top: 773px;left: 530px;\" src=\"/120/static/_content/34-text-9.png\"/>\n      <img class=\"halfScale 34-text-10\" style=\"top: 753px;left: 558px;\" src=\"/120/static/_content/34-text-10.png\"/>\n      <img class=\"halfScale 34-text-11\" style=\"top: 744px;left: 586px;\" src=\"/120/static/_content/34-text-11.png\"/>\n      <img class=\"halfScale 34-text-12\" style=\"top: 757px;left: 615px;\" src=\"/120/static/_content/34-text-12.png\"/>\n      <img class=\"halfScale 34-text-13\" style=\"top: 736px;left: 643px;\" src=\"/120/static/_content/34-text-13.png\"/>\n\n      ",
    "script": "\n        function onPageEnter() {\n          pg34Anim = new TimelineMax();\n\n          pg34Anim.fromTo(cOf(\"34-bar-1\"), 0.4, {y:20}, {y:0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"34-bar-2\"), 0.4, {y:35}, {y:0, ease: Power2.easeOut}, 1.2)\n          .fromTo(cOf(\"34-bar-3\"), 0.4, {y:75}, {y:0, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"34-text-1\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.4)\n          .fromTo(cOf(\"34-bar-4\"), 0.4, {y:155}, {y:0, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"34-text-2\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.6)\n          .fromTo(cOf(\"34-bar-5\"), 0.4, {y:265}, {y:0, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"34-text-3\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 1.8)\n          .fromTo(cOf(\"34-bar-6\"), 0.4, {y:340}, {y:0, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"34-text-4\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2)\n          .fromTo(cOf(\"34-bar-7\"), 0.4, {y:380}, {y:0, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"34-text-5\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.2)\n          .fromTo(cOf(\"34-bar-8\"), 0.4, {y:45}, {y:0, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"34-text-6\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.4)\n          .fromTo(cOf(\"34-bar-9\"), 0.4, {y:125}, {y:0, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"34-text-7\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.5)\n          .fromTo(cOf(\"34-bar-10\"), 0.4, {y:170}, {y:0, ease: Power2.easeOut}, 2.8)\n          .fromTo(cOf(\"34-text-8\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 2.6)\n          .fromTo(cOf(\"34-bar-11\"), 0.4, {y:310}, {y:0, ease: Power2.easeOut}, 3.0)\n          .fromTo(cOf(\"34-text-9\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3)\n          .fromTo(cOf(\"34-bar-12\"), 0.4, {y:340}, {y:0, ease: Power2.easeOut}, 3.2)\n          .fromTo(cOf(\"34-text-10\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.2)\n          .fromTo(cOf(\"34-bar-13\"), 0.4, {y:355}, {y:0, ease: Power2.easeOut}, 3.4)\n          .fromTo(cOf(\"34-text-11\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.4)\n          .fromTo(cOf(\"34-text-12\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.6)\n          .fromTo(cOf(\"34-text-13\"), 0.4, {opacity: 0}, {opacity:1, ease: Power2.easeOut}, 3.8)\n        }\n\n        function onPageLeave() {\n          pg34Anim.stop();\n        }\n      ",
    "searchText": "Dossier: Les femmes aux Jeux Olympiques  médias, le cinéma ou la musique n’ont pas encore réellement trouvé de solutions dans la lutte contre le sexisme. ■ Florence Carpentier est maîtresse de conférence à l’Université de Rouen (France) depuis 2004 et enseigne l’histoire du sport et de l’éducation physique. Depuis septembre 2018, elle est chercheuse senior à l’Université de Lausanne (Suisse). Ses recherches portent principalement sur l’histoire du CIO et des Jeux Olympiques. Elle travaille également sur l’émergence et le développement du sport dit «féminin» pendant la période de l’Entre-deuxguerres, en France et dans le monde. Elle est chercheuse au sein du Centre d’études des transformations des activités physiques et sportives (Université de Rouen) et au sein du Centre d’études olympiques et de la globalisation du sport (Université de Lausanne).  * Jane Misme, “Pourquoi les sportives doivent-elles voter ?”, La Française, 10 mars 1923. † Procès-verbal du 4e Congrès de la FSFI, 27-29 août 1926, Göteborg (Suède). Archives du Musée national du sport, Nice. ‡ Lettre de J. Sigfried Edström à Avery Brundage, 3 janvier 1935, Avery Brundage Collection, Archives du CIO, Lausanne.  Carpentier Florence (2018), “Alice Milliat: A Feminist Pioneer for Women’s Sport”, in Emmanuel Bayle and Patrick Clastres (Eds.), Global Sport Leaders. A biographical Analysis of International Sport Management. Palgrave, pp. 61-81. Carpentier Florence & Lefèvre Jean-Pierre (2006), “The Modern Olympic Movement, Women’s Sport and the Social Order During the Interwar Period”, The International Journal of the History of Sport, Vol. 23, Issue 7, pp. 938-964. Carpentier, Florence (2004), Le comité international olympique en crises. La présidence de Henri de Baillet-Latour (1925-1940). Paris, L’Harmattan.  Bibliographie de l’autrice: Carpentier, Florence (2022), “Les premiers jeux olympiques féminins (Paris, 1922). Internationalisme et droit de courir”, Revue d’histoire culturelle [en ligne].  50%  Milano Cortina 2026 – 47%  Beijing 2022 – 44,7%  Vancouver 2010 – 40,7%  Sarajevo 1984 – 21,5%  0%  Oslo 1952 – 15,7%  Jeux Olympiques d’hiver  Chamonix 1924 – 4,3%  Jeux Olympiques d’été  Paris 2024 – 50% Premiers Jeux Olympiques avec une représentation paritaire  10%  lÈgende  Atlanta 1996 – 34%  20%  Montréal 1976 – 20,7%  30%  Londres 2012 – 44,2% Premiers Jeux Olympiques avec des femmes dans chaque sport  40%  Londres 1948 – 9,5%  Pour la première fois aux Jeux Olympiques, Paris 2024 verra une égalité parfaite des genres sur les terrains, avec le même nombre d’hommes et de femmes participant dans tous les sports. Il s’agit d’un événement marquant et qui aura nécessité beaucoup de temps.  Notes de fin d’article  Paris 1924 – 4,4%  athlËtes fÈminines aux jeux  Carpentier, Florence (2019), “Alice Milliat et le premier ‘sport féminin’ dans l’Entre-deux-guerres”, 20&21. Revue d’histoire, n°142, pp. 93-107.  Elle est secrétaire générale du Comité européen d’histoire du sport.  Paris 1900 – 2,2% Première apparition aux Jeux Olympiques  34"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 34,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg35.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "As a proud Olympic and Paralympic Partner, Airbnb recognizes the importance of feeling at home while training on the road.  “Thanks to the support from Airbnb, I was able to start my journey to Paris 2024 strong!” Olympic hopeful Surﬁng, USA  In partnership, the IOC and Airbnb are proud to be supporting athletes on their Olympic and Paralympic journey through the Airbnb500 and the Airbnb Athlete Travel Grant programs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 35,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg36.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 36-title-1\" style=\"top:143px;left:44px\" src=\"/120/static/_content/36-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg36Anim = new TimelineMax();\n          pg36Anim.fromTo(cOf(\"36-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg36Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "36  Dossier: Hier et aujourd’hui  parIs: un sIËcle et deux olympIades B  ien qu’un siècle les sépare, les Jeux Olympiques de 1924 et 2024 partagent non seulement la même ville, mais aussi certains sites. Paris 1924 a marqué la première édition où les athlètes étaient regroupés au sein d’un village olympique, à Colombes, en proche banlieue parisienne. En 2024, les athlètes seront hébergés quelques kilomètres plus à l’est seulement, sur un site de 51 hectares à cheval sur les communes de Saint-Denis, de l’ÎleSaint-Denis et de Saint-Ouen. Vingt-et-un sites olympiques et 14 sites paralympiques seront situés dans un rayon de 10 km du village, les autres étant répartis dans la région Île-deFrance. Versailles, qui avait accueilli les épreuves de tir en 1924, verra se disputer les disciplines équestres et le pentathlon moderne. Le stade olympique de Colombes (rebaptisé stade Yves-duManoir) avait hébergé les cérémonies d’ouverture et de clôture de l’Olympiade 1924; l’été prochain, c’est le hockey sur gazon qui s’y disputera. Explorez un siècle des lieux mythiques et monuments olympiques de Paris en basculant entre les cartes de 1924 et 2024, et en utilisant les légendes pour comparer les sites de compétition.  lÈgende: sports de 1924 et 2024 1  Escrime  2 Taekwondo 3 Athlétisme (marche) 4 Cyclisme (sur route) 5 Volleyball de plage 6 Tennis 7 Boxe 8 Football  20 Basketball  37 Sports aquatiques (natation)  21 Athlétisme (ﬁn du marathon)  38 Pentathlon moderne  22 Badminton  39 Aviron  23 Gymnastique (rythmique)  40 Canoë slalom  24 Sports aquatiques (water-polo)  41 Canoë sprint  25 Sports aquatiques (natation artistique)  42 Voile 43 Polo  9 Volleyball  26 Sports aquatiques (plongeon)  10 Tennis de table  27 Rugby  45 Cyclisme (mountain bike (VTT))  11 Handball  28 Athlétisme  46 Cyclisme (piste)  12 Haltérophilie  29 Basketball (3×3)  47 Cyclisme (BMX racing)  13 Judo  30 Breaking  48 Golf  14 Lutte  31 Cyclisme (BMX freestyle)  49 Sports équestres (saut d’obstacles)  15 Cyclisme (départ du contre-la-montre individuel)  32 Skateboard  16 Tir à l’arc 17 Athlétisme (départ du marathon) 18 Gymnastique (artistique) 19 Gymnastique (trampoline)  1924 et 2024  33 Hockey 34 Cyclisme (arrivée du contre-la-montre individuel) 35 Triathlon 36 Sports aquatiques (natation de marathon)  1924  44 Tir  50 Sports équestres (dressage) 51 Sports équestres (concours complet) 52 Surf 53 Escalade sportive 54 Compétitions d’art  2024"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 36,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg37.jpg",
    "zoom": null,
    "content": "\n      <img class=\"halfScale 37-title-1\" style=\"top:802px;left:43px\" src=\"/120/static/_content/37-title-1.png\">\n\n      <img class=\"halfScale 37-img\" style=\"top:503px;left:75px\" src=\"/120/static/_content/37-img-1.png\">\n      <img class=\"halfScale 37-img\" style=\"top:419px;left:158px\" src=\"/120/static/_content/37-img-2.png\">\n      <img class=\"halfScale 37-img\" style=\"top:501px;left:196px\" src=\"/120/static/_content/37-img-3.png\">\n      <img class=\"halfScale 37-img\" style=\"top:722px;left:209px\" src=\"/120/static/_content/37-img-4.png\">\n      <img class=\"halfScale 37-img\" style=\"top:565px;left:296px\" src=\"/120/static/_content/37-img-5.png\">\n      <img class=\"halfScale 37-img\" style=\"top:676px;left:516px\" src=\"/120/static/_content/37-img-6.png\">\n      <img class=\"halfScale 37-img\" style=\"top:565px;left:625px\" src=\"/120/static/_content/37-img-7.png\">\n      <img class=\"halfScale 37-img\" style=\"top:277px;left:568px\" src=\"/120/static/_content/37-img-8.png\">\n      <img class=\"halfScale 37-img\" style=\"top:477px;left:523px\" src=\"/120/static/_content/37-img-9.png\">\n      <img class=\"halfScale 37-img\" style=\"top:308px;left:426px\" src=\"/120/static/_content/37-img-10.png\">\n      <img class=\"halfScale 37-img\" style=\"top:423px;left:308px\" src=\"/120/static/_content/37-img-11.png\">\n      <img class=\"halfScale 37-img\" style=\"top:287px;left:120px\" src=\"/120/static/_content/37-img-12.png\">\n      <img class=\"halfScale 37-img\" style=\"top:247px;left:229px\" src=\"/120/static/_content/37-img-13.png\">\n      <img class=\"halfScale 37-img\" style=\"top:163px;left:224px\" src=\"/120/static/_content/37-img-14.png\">\n      <img class=\"halfScale 37-img\" style=\"top:116px;left:186px\" src=\"/120/static/_content/37-img-15.png\">\n      <img class=\"halfScale 37-img\" style=\"top:130px;left:122px\" src=\"/120/static/_content/37-img-16.png\">\n    ",
    "script": "\n      function onPageEnter() {\n        pg37Anim = new TimelineMax();\n        pg37Anim.fromTo(cOf(\"37-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        .staggerFromTo(cOf(\"37-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.1)\n      }\n\n      function onPageLeave() {\n        pg37Anim.stop();\n        removeContentLinks();\n      }\n    ",
    "searchText": "sItes hors de parIs collIne díÈlancourt  vÈlodrome natIonal et stade bmx de saInt-quentInen-yvelInes 46  45  47  la concorde  stade de france  centre aquatIque 24  29  27  golf natIonal  ch‚teau de versaIlles  30  28  48  38  31  49  32  Aéroport ParisCharles de Gaulle  25 26 Aéroport ParisLe Bourget  50 51  pont alexandre III  sIte díescalade du bourget  34  53  35 arena parIs nord 36  7  33  vIllage olympIque  stade yves-du-manoIr  38  arena porte de la chapelle 22 23  grand palaIs  parIs la dÈfense arena  stade nautIque de vaIres-sur-marne  1  24  2  39  37  40 41 pont díIÈna 3 4 hÙtel de vIlle stade tour eIffel  17  5  arena champ-de-mars stade roland-garros 6  InvalIdes  13  15  14  16 21  7  parc des prInces 8  arena parIs sud  arena bercy  9  18 19  10 11  Aéroport Paris-Orly  12  parIs 2024  20"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 37,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg38.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 38-title-1\" style=\"top:802px;left:43px\" src=\"/120/static/_content/38-title-1.png\">\n\n        <img class=\"halfScale 38-img\" style=\"top:408px;left:309px\" src=\"/120/static/_content/38-img-1.png\">\n        <img class=\"halfScale 38-img\" style=\"top:486px;left:102px\" src=\"/120/static/_content/38-img-2.png\">\n        <img class=\"halfScale 38-img\" style=\"top:539px;left:57px\" src=\"/120/static/_content/38-img-3.png\">\n        <img class=\"halfScale 38-img\" style=\"top:618px;left:53px\" src=\"/120/static/_content/38-img-4.png\">\n        <img class=\"halfScale 38-img\" style=\"top:633px;left:96px\" src=\"/120/static/_content/38-img-5.png\">\n        <img class=\"halfScale 38-img\" style=\"top:643px;left:280px\" src=\"/120/static/_content/38-img-6.png\">\n        <img class=\"halfScale 38-img\" style=\"top:564px;left:302px\" src=\"/120/static/_content/38-img-7.png\">\n        <img class=\"halfScale 38-img\" style=\"top:556px;left:377px\" src=\"/120/static/_content/38-img-8.png\">\n        <img class=\"halfScale 38-img\" style=\"top:601px;left:502px\" src=\"/120/static/_content/38-img-9.png\">\n        <img class=\"halfScale 38-img\" style=\"top:526px;left:471px\" src=\"/120/static/_content/38-img-10.png\">\n        <img class=\"halfScale 38-img\" style=\"top:324px;left:473px\" src=\"/120/static/_content/38-img-11.png\">\n        <img class=\"halfScale 38-img\" style=\"top:294px;left:437px\" src=\"/120/static/_content/38-img-12.png\">\n        <img class=\"halfScale 38-img\" style=\"top:223px;left:497px\" src=\"/120/static/_content/38-img-13.png\">\n        <img class=\"halfScale 38-img\" style=\"top:88px;left:500px\" src=\"/120/static/_content/38-img-14.png\">\n        <img class=\"halfScale 38-img\" style=\"top:88px;left:455px\" src=\"/120/static/_content/38-img-15.png\">\n        <img class=\"halfScale 38-img\" style=\"top:87px;left:372px\" src=\"/120/static/_content/38-img-16.png\">\n        <img class=\"halfScale 38-img\" style=\"top:229px;left:330px\" src=\"/120/static/_content/38-img-17.png\">\n        <img class=\"halfScale 38-img\" style=\"top:224px;left:252px\" src=\"/120/static/_content/38-img-18.png\">\n        <img class=\"halfScale 38-img\" style=\"top:409px;left:58px\" src=\"/120/static/_content/38-img-19.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg38Anim = new TimelineMax();\n          pg38Anim.fromTo(cOf(\"38-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .staggerFromTo(cOf(\"38-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1.1)\n        }\n\n        function onPageLeave() {\n          pg38Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "lIlle  france mÈtropolItaIne Tout comme en 1924, le terrain des Jeux ne se limitera pas à la région parisienne: à l’époque, des épreuves avaient été organisées notamment au Havre et à Reims. Paris 2024 est resté ﬁdèle à son slogan, «Ouvrons grand les Jeux», pour impliquer différents territoires et mettre en valeur les plus beaux atouts de la France. Ainsi, les épreuves de naviganantes tion se dérouleront à Marseille 8 dans les eaux de la Méditerranée; le football se jouera dans sept magniﬁques stades répartis dans différentes régions; Lille accueillera les ch‚teauroux matches de qualiﬁcation du 44 basketball et la phase ﬁnale du handball. Par ailleurs, la lutte pour les 15 médailles des épreuves de tir se déroulera au cœur du pays, dans le centre de tir de classe mondiale du CNTS de Châteauroux.  11 20  parIs  lyon 8  st-ÈtIenne 8  nIce bordeaux 8  8 marseIlle 8 42  terrItoIres díoutre-mer Avec son spot de surf reconnu dans le monde entier et son décor spectaculaire, Teahupo’o (Tahiti) sera l’écrin sublime de la deuxième apparition du surf au programme olympique. En plus d’offrir aux athlètes des conditions optimales et l’occasion de se mesurer à l’une des plus belles vagues du monde, Teahupo’o permettra à Paris 2024 d’inclure l’ensemble de la France dans les Jeux Olympiques, en mettant en avant son héritage riche et diversiﬁé, tout en impliquant les communautés de la Polynésie française. teahupoío 52"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 38,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg39.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 39-img\" style=\"top:135px;left:354px\" src=\"/120/static/_content/39-img-1.png\">\n        <img class=\"halfScale 39-img\" style=\"top:281px;left:217px\" src=\"/120/static/_content/39-img-2.png\">\n        <img class=\"halfScale 39-img\" style=\"top:315px;left:208px\" src=\"/120/static/_content/39-img-3.png\">\n        <img class=\"halfScale 39-img\" style=\"top:375px;left:379px\" src=\"/120/static/_content/39-img-4.png\">\n        <img class=\"halfScale 39-img\" style=\"top:437px;left:532px\" src=\"/120/static/_content/39-img-5.png\">\n        <img class=\"halfScale 39-img\" style=\"top:419px;left:589px\" src=\"/120/static/_content/39-img-6.png\">\n        <img class=\"halfScale 39-img\" style=\"top:350px;left:543px\" src=\"/120/static/_content/39-img-7.png\">\n        <img class=\"halfScale 39-img\" style=\"top:311px;left:553px\" src=\"/120/static/_content/39-img-8.png\">\n        <img class=\"halfScale 39-img\" style=\"top:114px;left:462px\" src=\"/120/static/_content/39-img-9.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg39Anim = new TimelineMax();\n          pg39Anim.staggerFromTo(cOf(\"39-img\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.1, 1)\n        }\n\n        function onPageLeave() {\n          pg39Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "stade olympIque de colombes 3  4  8  17  sItes hors de parIs  stade de tennIs de colombes 6  camp de ch‚lons/ stand olympIque de ch‚lonssur-marne  palaIs de la socIÈtÈ des rÈgates du havre  hIppodrome du grand parquet  parc des sports de reIms/stand de la socIÈtÈ de tIr de reIms/stade olympIque de reIms  44  42  38  44  vIllage olympIque  18 21 27 28 38 49 50 51 bassIn díargenteuIl cercle de la voIle de parIs, meulan  39 stade nautIque des tourelles/ pIscIne des tourelles  42  24 26  stade de parIs  37 38  8 stade díescrIme de colombes/ stade de colombes 1  terraIn de polo de bagatelle  grand palaIs 54  43  hIppodrome díauteuIl  golf de saInt-cloud  51  43  8 stade bergeyre stade pershIng 8  vÈlodrome díhIver 1  7  12 14 vÈlodrome munIcIpal de vIncennes stand de versaIlles  auteuIl-vIllacoublay  38 44  51  stand díIssyles-moulIneaux 44  parIs 1924  46"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 39,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg40.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 40-title-1\" style=\"top:108px;left:43px\" src=\"/120/static/_content/40-title-1.png\">\n        <img class=\"halfScale 40-sub-1\" style=\"top:177px;left:42px\" src=\"/120/static/_content/40-sub-1.png\">\n      ",
    "script": "\n        function onPageEnter() {\n          pg40Anim = new TimelineMax();\n          pg40Anim.fromTo(cOf(\"40-title-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"40-sub-1\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg40Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "un foyer le temps des jeux UN SIÈCLE APRÈS SA PREMIÈRE APPARITION, LE VILLAGE OLYMPIQUE DEMEURE UNE PARTIE EMBLÉMATIQUE DE L’EXPÉRIENCE DES JEUX OLYMPIQUES, TANDIS QUE SON BUT ET SON HÉRITAGE CONTINUENT D’ÉVOLUER. PAR CONOR KETLEY  1  2  S  i les premières éditions des Jeux Olympiques modernes ont réuni les athlètes sur les terrains, aucun dispositif n’avait été préparé pour accueillir ceux qui se déplaçaient pour y participer. Le premier village olympique, bâti pour Paris 1924, a remédié à cela. Pour ces Jeux, de petits baraquements en bois avaient été édiﬁés pour accueillir la majorité des athlètes à quelques minutes de marche du stade de Colombes, l’enceinte du nord-ouest parisien où se déroulait la majorité des épreuves. Au-delà de l’aspect pratique de loger tous les athlètes, ces maisonnettes  avaient surtout pour objectif de rassembler tous les participants en un même lieu, au sein d’un petit village qui possédait son propre bureau de poste, son bureau de change, ainsi qu’un restaurant. «Par le contact qu’ils créent entre les jeunesses de tous les pays, [les Jeux Olympiques] contribuent à développer cette atmosphère de cordialité qui apprend aux hommes à mieux se connaître d’abord, puis à mieux s’estimer, ce à quoi les Jeux de Paris, […] auront puissamment aidé.» Ce sont les mots de Frantz Reichel, le secrétaire général du comité d’organisation"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 40,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg41.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "41  3  Bien plus qu’un hébergement  des Jeux Olympiques de Paris 1924 dans le rapport officiel des Jeux. Par cette déclaration, il tenait à souligner combien le Mouvement olympique avait évolué depuis le Congrès olympique inaugural de 1894. Et lors du siècle qui a suivi, le village olympique a endossé un rôle encore plus important dans l’uniﬁcation du Mouvement olympique.  Pour la plupart des villes qui accueillent les Jeux Olympiques, il serait certainement possible de loger les participants dans des hébergements privés, comme des hôtels. Cependant, le village olympique est devenu une partie si emblématique de l’expérience des Jeux pour les athlètes qu’il est désormais impossible d’imaginer une Olympiade sans lui. Au ﬁl du temps, le village s’est révélé être le véritable creuset des Jeux. Au total, 205 nations et l’équipe olympique des réfugiés du CIO ont été représentées à Tokyo 2020. Le village est l’endroit où les athlètes de tous les pays peuvent se rassembler, loin des projecteurs. C’est ici que naissent des amitiés qui peuvent durer toute une vie. «Si vous supprimez le village, vous supprimez une partie des Jeux», souligne Henri Specht, directeur du projet de village olympique et paralympique à la SOLIDEO, la société de génie civil en charge des infrastructures du village. «C’est probablement le seul lieu et le seul moment sur la planète où vous avez autant de pays qui se croisent au même endroit. Je pense que l’ensemble des nations sont très attachées à ce village, et les athlètes qui y ont vécu en ressortent avec une expérience de vie assez unique.»  L’évolution du village 1 Après la clôture des Jeux, le village olympique accueillera 6 000 résidents. 2 Le premier village olympique de Paris 1924 prévoyait la construction de logements temporaires. 3 Le site du village aidera à développer trois communes dans le nord de Paris, le long de la Seine.  L’impact social a grandi avec le temps pour ceux qui vivent au sein du village olympique, tout comme pour ceux qui vivent en dehors. Paris 2024 offre une réelle opportunité de créer aux abords de la capitale française un  espace moderne prenant en compte l’accessibilité et l’impact environnemental. La différence majeure entre Paris 1924 et Paris 2024 est que le village olympique est désormais construit en ayant en tête sa reconversion, comme cela a été le cas lors des récentes éditions des Jeux. L’objectif n’est plus de bâtir des structures temporaires vouées à être détruites après avoir logé les athlètes pendant quelques semaines: désormais, le but est de créer un impact durable aux retombées positives pour les habitants du Grand Paris. Le village olympique sera situé à sept kilomètres au nord du centre de Paris, sur les communes de Saint-Denis, de l’Île-Saint-Denis et de Saint-Ouen, à moins de cinq minutes du Stade de France. Sept des 51 hectares qu’il couvre seront dédiés aux espaces verts, avec notamment un parc public bâti en son centre, et quelque 9 000 arbres et arbustes ont été plantés dans le village. «Le village, c’est pour nous avant tout une opération d’aménagement et d’urbanisme», explique Henri Specht. «Le programme Héritage est notre première priorité. On proﬁte des Jeux pour s'adresser à des publics les plus larges possible.» Le village olympique vivra donc une première vie au cours de l’été 2024, avant de se transformer un an plus tard, lorsqu’il est prévu qu’il s’ouvre à 6 000 nouveaux habitants. S’il ne faut pas perdre de vue que les Jeux Olympiques et Paralympiques sont la raison d’être du village olympique, l’héritage qui bénéﬁciera à la ville hôte est dorénavant tout aussi important. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 41,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg42.jpg",
    "zoom": null,
    "content": "\n        <img id=\"42-title-1\" class=\"halfScale\" style=\"top:110px;left:108px\" src=\"/120/static/_content/42-title-1.png\"/>\n        <img id=\"42-title-2\" class=\"halfScale\" style=\"top:317px;left:121px\" src=\"/120/static/_content/42-title-2.png\"/>\n        <img id=\"42-sub-1\" class=\"halfScale\" style=\"top:238px;left:111px\" src=\"/120/static/_content/42-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg42Anim = new TimelineMax();\n          pg42Anim.fromTo(idOf(\"42-title-1\"), 0.8, {opacity:0, y:-40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"42-title-2\"), 0.8, {opacity:0, y:40},{opacity:1, y:0, ease: Power4.easeOut}, 1)\n          .fromTo(idOf(\"42-sub-1\"), 0.4, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.2)\n        }\n\n        function onPageLeave() {\n          pg42Anim.stop();\n          removeContentLinks();\n      }\n      ",
    "searchText": "‡ travers NOUS FÊTERONS L’ÉTÉ PROCHAIN UN SIÈCLE DE PROGRÈS ET DE DÉVELOPPEMENT DEPUIS PARIS 1924. LA REVUE OLYMPIQUE REMONTE LE FIL DE L’ÉVOLUTION DES JEUX AVEC CETTE SÉLECTION DE CLICHÉS.  líobjectIf  01  01.  Le pont Alexandre III, avec ses quatre statues emblématiques en bronze doré, enjambe la Seine pour relier les Invalides au Grand Palais.  02.  Ce célèbre monument accueillera plusieurs épreuves lors des Jeux de Paris 2024, comme la natation de marathon et le triathlon."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 42,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg43.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 43,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg44.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01 02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 44,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg45.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03 04 01.  Les spectateurs garnissant les tribunes à Paris 1924.  02.  Le breaking est l’un des nouveaux sports urbains qui fera ses débuts à Paris 2024, marquant une profonde évolution du programme sportif des Jeux.  03.  Un gymnaste français exécute une ﬁgure lors d’une fête organisée avant les Jeux, près du pont Alexandre III.  04.  La plateforme des 10 m de l’épreuve de plongeon à Paris 1924, à la piscine des Tourelles."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 45,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg46.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01  01  01.  Deux athlètes japonais se détendent dans le tout premier village olympique de l’histoire des Jeux, situé près du stade de Colombes.  02.  Passage de la rivière pour le ﬁnlandais Ville Ritola et le français Paul Bontemps dans la ﬁnale olympique du 3 000 m steeple.  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 46,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg47.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "omegawatches.com  R E C O R D I N G O LYM P I C D R E A M S Les Jeux Olympiques sont l’occasion pour beaucoup d’athlètes de réaliser leurs rêves. C’est pourquoi, depuis 1932, nous sommes passionés par notre rôle de &KURQRP«WUHXU2IÿFLHOHWQRXVPHWWRQVQRWUHÿDELOLW« précision et savoir-faire à disposition des sportifs."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 47,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg48.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "01 01  01.  Le BMX freestyle fera son retour à Paris 2024, après avoir rencontré un franc succès dans la précédente édition des Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 48,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg49.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 49,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg50.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "50  À travers l'objectif  01  01.  Le tandem français champion olympique de vitesse aux Jeux Olympiques de Paris 1924: Jean Cugnot et Lucien Chouly.  02.  Le poste de la T.S.F. (transmission sans ﬁl) installé sur le terrain du stade olympique de Colombes.  03.  Des enfants prennent des cours de skateboard au skatepark «Terre de Jeux» récemment inauguré à Pontoise, au nord-ouest de Paris.  02"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 50,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg51.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "03"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 51,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg52.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 52-title\" style=\"top:548px;left:44px\" src=\"/120/static/_content/52-title-1.png\"/>\n\n        <img \n          class=\"abs halfScaleC halfpulse animatedpulse pointer\" \n          style=\"top:439px; left:33px;\"\n          onclick=\"pg52_gallery(0)\" \n          src=\"/120/static/_content/white-camera.png\"\n        />\n      ",
    "script": "\n        function onPageEnter() {\n          pg52Anim = new TimelineMax();\n          pg52Anim.fromTo(cOf(\"52-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg52Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "des jeux pour une nouvelle Ëre"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 52,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg53.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 53-sub\" style=\"top:110px;left:341px\" src=\"/120/static/_content/53-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg53Anim = new TimelineMax();\n          pg53Anim.fromTo(cOf(\"53-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg53Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "DANS UN AN, LA FRANCE ET PARIS ACCUEILLERONT POUR LA TROISIÈME FOIS LES JEUX OLYMPIQUES D’ÉTÉ ET REJOINDRONT EN CELA LONDRES (1908, 1948 ET 2012) ET PRÉCÉDERONT LOS ANGELES (1932, 1984 ET 2028). PAR ALAIN LUNZENFICHTER  Paris innovera en amenant les événements sportifs au cœur de la ville."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 53,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg54.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  D  epuis les Jeux de Paris de 1900, mais aussi 1924, cette grande fête du sport a bien changé et aujourd’hui l’organisation de cet événement n’a plus rien à voir avec celle de 1924. Le retentissement des Jeux Olympiques au début du siècle dernier est sans commune mesure avec celui que nous lui connaissons au XXIe siècle. Tout simplement parce que le monde a changé, le sport a changé, le CIO a changé, ce qui implique que les Jeux Olympiques ont changé. Les chiffres sont là et nous montrent que nous ne sommes plus dans le même univers, la même planète sportive. Ce qui, en 1924, était un événement encore à ses balbutiements représente aujourd’hui l’équivalent de trente-deux championnats du monde en même temps et, pour la grande majorité, dans la même ville. Une organisation  qui se contentait jadis des installations d’un club, le Racing Club de France, certes l’un des plus grands au monde, nécessite aujourd’hui de multiples installations qui ne peuvent être mises en place qu’à l’échelle d’un pays. Si Paris 1924 avait été la première organisation olympique à construire un village olympique, un certain nombre de participants vivaient à l’hôtel. Paris 2024 va mettre en place un village olympique qui va recevoir plus de 15 000 personnes. Pourtant, le site le plus important des Jeux Olympiques de 1924, le stade de Colombes, aura à nouveau le privilège d’accueillir un sport un siècle plus tard: le hockey sur gazon. Ayant fait l’objet de travaux de modernisation, le stade Yves-du-Manoir constituera un héritage des Jeux puisqu’il abritera le siège de la Fédération Française de Hockey (sur gazon).  Des chiffres impressionnants Tous les chiffres qui semblaient impressionnants au lendemain de la Première Guerre mondiale sont aujourd’hui décuplés. Les Jeux Olympiques, antre de l’amateurisme pur et dur, sont passés au professionnalisme triomphant et se sont mondialisés. En 1924, les athlètes venaient de 45 pays dont 27 européens. En 2024, le Vieux Continent ne sera plus majoritaire sur les nations qui viendront dans la Ville lumière pour en découdre. Avec 10 500 concurrents, nous serons également loin des 3 089 de 1924. Changement majeur, la participation féminine (135 femmes en 1924*) va évoluer l’an prochain sur les sites des compétitions. L’Agenda olympique 2020, mis en place en 2014 lors de la Session de Monaco, a fortement changé la donne car pour la"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 54,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg55.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://www.youtube.com/watch?v=tqSEoFnHC88\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:256px;top:551px\" src=\"/120/static/_content/white-play.png\"/>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  55  Numéro 120  première fois de l’histoire, une parité parfaite sera de mise aux Jeux Olympiques de Paris 2024. 5 250 hommes et autant de femmes disputeront les 32 sports et les 329 épreuves. Depuis un siècle, les possibilités de voyage ont elles aussi décuplé et se sont mondialisées. Ce qui change bien des choses au niveau de la participation des spectateurs à l’événement. En 1924, on a compté quelque 600 000 spectateurs pendant toute la durée des Jeux et il est impossible de savoir combien d’étrangers étaient à Paris du 5 au 27 juillet 1924. Cette fois, presque dix millions de billets sont en vente à un public du monde entier. Ce chiffre atteint les 13,5 millions si l’on compte les Jeux Paralympiques qui n’existaient pas en 1924. Pourtant, ce qui a le plus révolutionné l’ampleur des Jeux Olympiques, c’est la montée en puissance des médias. Durant des dizaines d’années, seuls la presse écrite et les photographes ont dominé le marché. L’avènement de la radio offre à l'Olympisme une occasion de faire entendre sa voix dès 1924… Ainsi naît le suspense, le rêve: «la voix aide à voir». Depuis, la télévision a donné aux Jeux ses lettres de noblesse. Si le nombre de journalistes n’était que de 685 en 1924 – avec de rares femmes – plus de 25 000 médias (majoritairement de télévision) seront présents l’an prochain et les Jeux, retransmis sur plus de 220 pays et territoires, entreront dans tous les foyers de la planète. Là réside leur succès. Pour tout dire, alors que les Jeux Olympiques de 1924 se limitaient au public français, ceux de Paris 2024 se dérouleront sous le regard du monde. Autre changement majeur, un village va également être construit à l’intention des médias à quelques encablures de l’aéroport de Paris-Le Bourget et du Stade de France. À un siècle d’écart, l’événement n’a plus rien à voir. Il y a 100 ans, il s’agissait simplement d’une réunion sportive mondiale. Aujourd’hui, pendant la dizaine d’années entre la phase de candidature et le début des Jeux, on travaille à ce que chaque Français se sente concerné par l’organisation. Paris 2024 n’est pas un privilège uniquement réservé à la capitale, c’est également celui de la France entière puisque  1 Les Jeux Olympiques de Paris 2024 veulent encourager les jeunes à faire du sport. 2 Entre 140 et 170 barges transporteront les athlètes le long de la Seine lors de la cérémonie d’ouverture.  plusieurs autres villes de l’Hexagone auront l’apanage d’accueillir des épreuves. Marseille, Châteauroux, Lille et même Tahiti seront le cadre de compétitions olympiques, bien que ce soit à Paris et dans sa région que se déroulera la majorité des épreuves. Dès le lendemain de la remise du drapeau olympique à la ville de Paris, une traversée de la France a été entreprise par une équipe de Paris 2024 avec trois drapeaux: les anneaux olympiques, les agitos paralympiques et, bien sûr, l’emblème de l’organisation. Cette première marche n’était qu’un premier étage de la fusée olympique, le deuxième étant la mise en place de «Terre de Jeux 2024». Ce label permet de mettre en contact les différents acteurs du sport, des Fédérations Nationales aux acteurs à l’échelle locale mais aussi les ambassades françaises, pour favoriser la création de projets communs et donner une dimension nationale aux Jeux. C’est la volonté de Tony Estanguet: «J’ai envie que, grâce à ces Jeux, on renforce la place du sport dans la société. Pour cela, il faut associer l’ensemble des territoires parce que les “bras armés” de “plus de sport dans ce pays”, ce sont toutes les petites collectivités, là où on a tous commencé.» Les Journées olympiques du 23 juin étaient également mises en place aﬁn d’encourager  2  l’appétence des Français pour le sport et les Jeux. De grands champions étaient présents pour partager leur passion et échanger avec leur public et les participants ont pu vibrer devant des démonstrations. Par ailleurs, «Terre de Jeux 2024» a organisé un relais mondial sur 24 heures lequel a débuté en NouvelleZélande et s’est achevé à Tahiti pour célébrer le compte à rebours des 500 jours avant les Jeux Olympiques de Paris 2024.  Un demi-million de spectateurs pour la cérémonie d’ouverture Sortie de son cadre historique, à savoir le stade olympique, la cérémonie d’ouverture des Jeux Olympiques de Paris marquera une rupture avec les précédentes éditions. Sa direction a d’ailleurs été conﬁée à Thomas Jolly – directeur du Quai à Angers, remarqué pour sa saga de dix-huit heures tirée de l’œuvre de Shakespeare Henry VI au théâtre de l’Odéon et d’une nouvelle version de Starmania – qui va embraser la Seine. Paris 2024 casse les codes de la compétition sportive en faisant entrer le sport dans la ville, il en sera de même pour la cérémonie d’ouverture. Ainsi, entre le pont d’Austerlitz et le Trocadéro, où le ﬁnal des spectacles et celui des cérémonies protocolaires se dérouleront, le déﬁlé des athlètes aura lieu sur six"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 55,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg56.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "56  Dossier: Rendez-vous à Paris en 2024  kilomètres le long de la Seine et sur 140 à 170 barges dédiées aux délégations nationales. De nombreuses caméras permettront aux téléspectateurs d’être au plus près des athlètes. Alors que généralement une cérémonie d’ouverture regroupe environ 60 000 spectateurs, ils seront au moins huit fois plus sur les bords de la Seine, dont plus de 80% pourront assister gratuitement à l’événement. Quatre-vingts écrans géants, disposés dans tout Paris, permettront au plus grand nombre de suivre la cérémonie en direct. Et où placera-t-on la vasque olympique aﬁn qu’elle soit embrasée par la ﬂamme et reste allumée tout au long des Jeux? Thomas Jolly a bien sa petite idée: «Ce qui serait beau, ce serait de la laisser sur l’eau, comme une bougie ﬂottante. Mais il faut que la ﬂamme soit grosse, qu’elle ressemble au logo et qu’elle puisse être mobile. La ville deviendra le décor vivant d’un moment d’exception, les di%érents tableaux d’un spectacle mettront en scène les monuments, ponts et établissements culturels qui bordent la Seine.» Si les Jeux attireront des spectateurs du monde entier, il y aura également des endroits où suivre les compétitions pour ceux qui n’auront pas réussi à obtenir de billets d’entrée pour les di%érents stades: les fameuses fan zones qui, bien entendu, n’existaient pas en 1924; mais surtout le parc de la Villette où sera implanté le «Club France», l’un des sites de célébration o%iciels à l’été 2024, et où seront proposées 200 heures de retransmissions en direct. Le parc pourra, chaque jour, accueillir entre 50 000 et 100 000 personnes. Une ambiance extraordinaire, c’est certain.  1  Organiser des Jeux festifs a toujours été la ligne directrice de Paris, et ce dès la phase de candidature. Des Jeux qui sortent de l’ordinaire et pour lesquels les monuments de Paris et de sa proche banlieue serviront d’écrin pour certaines compétitions. Le sport investi complètement la Ville lumière avec, par exemple, l’escrime et le taekwondo au Grand Palais, le beach volley à la tour Ei%el, la partie natation du triathlon dans la Seine, l’équitation et le pentathlon moderne au château de  Versailles. Et pour les plus jeunes des concurrents, l’organisation a décidé que les sports urbains devaient sortir et s’épanouir hors des stades traditionnels, au cœur de la ville. Durant pratiquement toute la durée des Jeux, du 27 juillet au 10 août, la place de la Concorde sera le cadre du BMX freestyle, du breaking, du skateboard et du basketball 3×3. L’athlétisme et le cyclisme, deux sports majeurs des Jeux, seront, pour la première fois de l’histoire olympique, ouverts au public qui pourra ainsi dire «j’ai participé aux Jeux Olympiques». Le marathon sera l’une de ces deux épreuves. Un marathon révolutionnaire et symbolique puisqu’il s’inscrit dans l’histoire de France. Il s’agit d’un aller-retour entre Paris et Versailles. En e%et, les 5 et 6 octobre 1789, la capitale est touchée par la disette lorsque 6 000 à 7 000 femmes réclamant du pain partent de l’Hôtel de Ville de Paris et marchent ensemble jusqu’à Versailles pour manifester leur détresse auprès de Louis XVI et exiger  1 Le mythique Grand Palais accueillera les compétitions d’escrime et de taekwondo. 2 Les compétitions masculines et féminines de golf se dérouleront au prestigieux Golf National. 3 Les mascottes des Jeux, les Phryges, sont un symbole de liberté."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 56,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg57.jpg",
    "zoom": null,
    "content": "\n        <a href=\"https://fb.watch/lB834ma5O3/\" target=\"_blank\">\n          <img class=\"abs halfpulse animatedpulse halfScaleC pointer\" style=\"left:255px;top:348px\" src=\"/120/static/_content/white-play.png\"/>\n        </a>\n      ",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  Numéro 120  2  L’athlétisme et le cyclisme seront, pour la première fois de l’histoire olympique, ouverts au public. des réformes, ce qui aboutira à la ratiﬁcation de la Déclaration des droits de l’homme et du citoyen, et au retour du roi aux Tuileries. Le parcours intra-muros parisien permettra également aux coureurs de voir l’opéra Garnier et la pyramide du Louvre. Pour lancer l’événement, le double champion olympique de la distance Eliud Kipchoge (Kenya) était venu dans la capitale. Un 10 km sera également proposé pour ceux qui ne se sentiraient pas assez entraînés pour a%ronter les 42,195 km du marathon. L’autre épreuve populaire sera une course cycliste qui se déroulera au parc de la Courneuve, non loin du Stade de France. Pour continuer avec le côté révolutionnaire, Paris 2024 a depuis dévoilé ses mascottes. Contrairement à une tradition mise en place depuis 1972, le comité d’organisation n’a pas choisi un petit animal pour représenter l’organisation parisienne. Ce sont les Phryges qui ont été sélectionnées. Un choix curieux pour un étranger mais dans le ton de ce que  3  souhaitent les responsables de Paris 2024. Les Phryges s’inspirent d’un vêtement, symbole de liberté, présent dans notre histoire depuis des siècles, et qui est apparu dès l’Antiquité. Présent sur des drapeaux d’Amérique latine avant d’être popularisé par les révolutionnaires français, le bonnet phrygien est aujourd’hui bien connu de l’imaginaire populaire français. Symbole révolutionnaire, de la République et de liberté, le bonnet phrygien coi%e Marianne dans nos mairies ou sur nos timbres. Nos Archives nationales révèlent des traces de Phryges bâtisseuses dès 1163 sur le chantier de la cathédrale Notre-Dame de Paris.  Des Jeux durables Face au plus grand déﬁ de l’humanité, aux enjeux environnementaux et sociétaux de notre siècle, le monde du sport se devait de prendre sa part de responsabilité. En réduisant de moitié les émissions liées à l’organisation des Jeux et en compensant encore plus d’émissions de CO2 que celles qu’ils vont émettre, les Jeux Olympiques de Paris 2024 seronts inédits et durables. Parce que les Jeux invitent à voir plus grand et plus loin, l’organisation parisienne doit participer à l’accélération de la transition écologique dans le sport, les territoires et les grands  événements. C’est pour cela que la ville de Paris va mettre en place un réseau cyclable de 60 km de long qui permettra de relier tous les sites de compétition. Toutes ces pistes seront aménagées avec une signalétique dédiée. Aux abords des sites olympiques, elles seront parées des pictogrammes et des couleurs de Paris 2024. Ces grands axes olympiques seront conservés en héritage après l’événement et entreront dans le quotidien des Parisiennes et des Parisiens. Ces pistes et les nombreuses autres innovations font toutes partie de la transformation de Paris qui, dans un an, ne sera pas seulement le théâtre d’un événement sportif, mais également d’une expérience pour chacun – athlètes, spectateurs, habitants et téléspectateurs du monde entier. Dans les pages qui suivent, des personnalités jouant un rôle central dans la mise en œuvre des initiatives de la ville jusqu’aux Jeux, et au-delà, nous font part de leur vision. ■  Notes de fin d’article * Ces chiffres peuvent varier quelque peu selon les documents historiques consultés."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 57,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg58.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 58-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/58-line-1.png\"/>\n        <img id=\"58-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/58-quote-1.png\"/>\n        <img class=\"halfScale 58-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/58-line-1.png\"/>\n        <img class=\"halfScale 58-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/58-title-1.png\"/>\n        <img id=\"58-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/58-img-1.png\"/>\n        <img class=\"halfScale 58-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/58-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg58Anim = new TimelineMax();\n          pg58Anim\n            .fromTo(cOf(\"58-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"58-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"58-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"58-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"58-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg58Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  nous sommes dans les temps  1  N michel cadot Haut fonctionnaire, préfet de Paris après plusieurs postes préfectoraux en province, Michel Cadot est nommé délégué interministériel aux Jeux Olympiques et Paralympiques 2024 et délégué interministériel aux grands événements sportifs le 17 août 2020.  ous sommes dans les temps. Nous avons très correctement avancé dans la préparation des Jeux car nous avons aujourd’hui une gouvernance bien en place avec le président de la République et la Première ministre qui tiennent régulièrement des réunions avec les ministres impliqués dans le projet. Il y a une très bonne articulation entre ce niveau central, le comité d’organisation des Jeux Olympiques (COJO) et le niveau territorial avec les préfets. Pour notre part, nous tenons à ce que les délais soient tenus et que les étapes soient franchies dans de bonnes conditions. Pour la livraison des infrastructures, nous sommes dans les délais et dans les budgets. Il faut savoir qu’il y a 64 ouvrages qui sont suivis et cela se passe bien. Le COJO a accéléré dans la passation de ses marchés et sur l’organisation des épreuves tests. Le projet de loi olympique a été largement plébiscité par le parlement. Dans les prochains mois, nous allons vers une"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 58,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg59.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "59  mobilisation très forte sur les problèmes de sécurité, de transport et de mobilité. Il faut mobiliser toutes les forces de sécurité intérieure et ﬁnaliser les plans de sécurité de chaque site de compétitions. C’est une ampleur d’événement très importante quand on compare avec l’Euro 2016 de football par exemple, sur l’Île-de-France. Cela va être dix fois plus conséquent en termes de temps, de sécurité à garantir et de conditions globales de sécurisation dans l’espace ouvert de la cérémonie d’ouverture sur la Seine. La cybersécurité est un sujet à part qui pose des problèmes de technologies et de droit. Les éditions précédentes des Jeux Olympiques nous ont montré que l’on peut rencontrer des déﬁs majeurs liés à cette question. Nous allons proﬁter de l’organisation de la Coupe du monde de rugby (qui aura lieu en France aux mois de septembre et octobre de cette année) pour aguerrir les services de l’État. Il nous faut également trouver des logements pour accueillir les 25 000 renforts de sécurité  intérieure pour la seule Île-de-France. Il faut surtout acquérir une adhésion populaire grâce à des zones de célébrations sur tout le territoire français, mais aussi avec une participation massive dans les stades. L’État a fait le nécessaire en achetant un grand nombre de places pour les redistribuer au plus grand nombre. Le parcours de la ﬂamme, lui aussi, doit être le prétexte à la fête. L’héritage, on le mesurera e%ectivement à la ﬁn des Jeux Olympiques. On a prévu de le faire avec des études d’impacts avant les Jeux puis à l’issue de ceux-ci. Je dirais que notre volonté, c’est d’abord des bénéﬁces matériels et économiques grâce, en particulier, aux 64 ouvrages qui ont été rénovés, transformés ou construits en France, de Marseille à Lille ou à Châteauroux. Cela passe aussi par un plan de l’État avec 5 000 équipements de proximité qui, bien sûr, resteront après l’événement. Mais ce sont aussi des retombées économiques considérables au niveau des marchés: les petites et moyennes entreprises seront privilégiées avec l’insertion  professionnelle des personnes éloignées de l’emploi, en particulier dans le département de la Seine-Saint-Denis. Le tourisme, qui sera évidemment plus important que les années précédentes, sera aussi concerné tout comme la transformation du département du 93, notamment à Saint-Denis, Saint-Ouen et l’Île-Saint-Denis mais aussi dans sa partie Dugny, la Courneuve et le Bourget. Le village des athlètes laissera en héritage un quartier urbain, innovant et ambitieux, un écoquartier mixte d’habitat social, intermédiaire et libre comprenant plus de 6 000 logements ainsi que des bureaux, au milieu de 7 hectares d’espaces verts. De plus, il sera neutre en carbone. Il en sera de même du village des médias construit à Dugny. Cela permettra de renforcer l’attractivité de ce département et de répondre aux carences importantes en logements de cette partie de l’Île-de-France. Des franchissements d’autoroute seront construits, comme le pont qui va relier la piscine olympique de Saint-Denis et le Stade de France, et un autre à la hauteur de Dugny. Les bassins olympiques de Paris 2024 seront légués après les Jeux à trois villes de Seine-Saint-Denis (Pierreﬁtte, Sevran, Bagnolet) où 60% des élèves des classes de sixième ne savent pas nager… J’ajoute à cela les bassins de Marville et d’Aubervilliers. J’ai beaucoup insisté pour que l’on améliore l’accessibilité de tous les stades olympiques aux personnes en situation de handicap, car il faut qu’ils participent à la fête. Pour ﬁnir, les stratégies environnementales de la SOLIDEO et de l’État sont tout aussi ambitieuses. Elles visent à réduire de moitié les émissions de gaz à e%et de serre issues des chantiers en utilisant au maximum le bois, l’électriﬁcation des stades pour éviter les groupes électrogènes, la décarbonisation de la ﬂotte de bateaux sur la Seine ou le développement de la part modale du vélo dans les transports du quotidien avec, aujourd’hui, plus de 280 km de pistes cyclables avec des parkings.  1 Le centre aquatique deviendra une installation multisports pour le public après les Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 59,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg60.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 60-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/60-line-1.png\"/>\n        <img id=\"60-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/60-quote-1.png\"/>\n        <img class=\"halfScale 60-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/60-line-1.png\"/>\n        <img class=\"halfScale 60-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/60-title-1.png\"/>\n        <img id=\"60-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/60-img-1.png\"/>\n        <img class=\"halfScale 60-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/60-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg60Anim = new TimelineMax();\n          pg60Anim\n            .fromTo(cOf(\"60-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"60-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"60-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"60-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"60-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg60Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  ouvrons grand les jeux  tony estanguet est triple champion olympique (2000, 2004, 2012) et du monde (2006, 2009, 2010) de canoë slalom, ancien membre du Comité International Olympique et président du comité d’organisation des Jeux Olympiques de Paris 2024.  C  es Jeux, je les vois grands. Cela fait si longtemps que l’on en a rêvé, que l’on y a travaillé. Je connais les liens forts qui relient la France et l’Olympisme. Je les rêve inédits car notre pays a tous les atouts pour organiser de grands Jeux, des Jeux exceptionnels. Ce n’est pas seulement la 33e édition d’été du plus grand événement sportif de la planète, mais comptez sur nous pour renverser le modèle mis en place au ﬁl des organisations précédentes. Je rêve de Jeux qui vont marquer l’histoire de l’Olympisme, car nous voulons rendre chaque moment de l’événement le plus impactant possible. Le premier moteur consiste à offrir à l’Olympisme un côté spectaculaire et magique et à démocratiser le sport à tous les niveaux aﬁn de le rendre accessible à plus de monde: dans les écoles, dans les villes avec notre programme «Terre de Jeux 2024» et les 4 millions de personnes qui se sont inscrites au «Club Paris 2024». Je demande à mes collaborateurs d’être ambitieux. Cela crée certaines difficultés, mais notre travail c’est de trouver les solutions pour réaliser l’ambition la plus grande pour Paris 2024. Notre scénario idéal, ce sont des Jeux ouverts. Il faut de l’audace, penser des moments à part et rendre cette édition des Jeux unique avec une cérémonie d’ouverture différente et des compétitions dans des sites du centre de Paris. Cela permettra d’offrir aux athlètes la scène la plus valorisante pour eux et, pour les téléspectateurs, un spectacle inoubliable et une célébration grandiose. «Ouvrir grand les Jeux» permet de trouver des symboles, des marqueurs qui en feront un événement différent et qui apporteront à l’histoire des Jeux une signature nouvelle. La France a toujours marqué l’histoire des Jeux Olympiques. Il y a eu 1900, 1924, 1968, 1992 et il y a eu des choses fortes qui se sont déroulées dans notre pays. Qui ne se rappelle pas de la cérémonie d’ouverture d’Albertville de Philippe Découﬂé. Grandiose! Les Jeux Olympiques doivent continuer à faire rêver les gens et leur mettre des étoiles dans les yeux tout en mettant en avant la durabilité, en privilégiant les infrastructures existantes, en réduisant l’impact carbone et en luttant contre la sédentarité. Il ne faut pas oublier que l’Organisation mondiale de la santé a annoncé que 80% des adolescents ne font pas su%isamment de sport. En France, on est classé 117e pays sur"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 60,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg61.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  140 en matière de sédentarité, c’est dire qu’il y a beaucoup de travail à faire pour changer la donne… Pour cela, nous avons travaillé avec le ministère de l’Éducation nationale sur l’organisation de 30 minutes de sport par jour dans les écoles primaires pour développer le respect, le dépassement de soi-même, des qualités qu’il faut acquérir. On peut mettre plus de sport dans le quotidien des Français. On a 180 000 clubs en France avec de nombreuses disciplines. Il y a forcément un club qui peut convenir aux aspirations de chacun. Paris 2024, c’est un peu l’assemblage de la magie et de l’utilité des Jeux Olympiques et il nous faut le démontrer. C’est le plus di%icile, car nous sommes dans un contexte social et économique qui n’est pas favorable. Nous ne devons pas reculer, mais utiliser les Jeux pour faire évoluer les mentalités sur les bienfaits du sport pour la société. Les Jeux Olympiques, c’est une fois dans une vie, il faut être au rendez-vous avec l’histoire. En ce qui concerne l’héritage, nous gardons le classique: le matériel, en le limitant au strict nécessaire. Des logements, des infrastructures de transport et sportives. Il y a une seule  piscine olympique mais, en face, nous avons une vingtaine de piscines qui sont rénovées, 5 000 équipements de proximité portés par l’État. Mais l’héritage le plus important, pour nous, est immatériel. Nous avons trois dominantes: l’une est écologique en pensant à l’impact que cela génère, comment on le réduit en ayant des attitudes et des comportements plus responsables pour diminuer le plastique, limiter les transports, les constructions, en déﬁnitive pour réduire l’impact carbone. Le deuxième héritage immatériel, c’est la lutte contre la sédentarité en mettant à proﬁt tous ces écosystèmes de «Terre de Jeux 2024», de clubs, d’entreprises, la Semaine Olympique et Paralympique auxquelles un million d’élèves ont participé… Multiplier ces opportunités pour montrer de manière régulière que le sport est un besoin vital pour toutes les générations. La troisième dominante en matière d’héritage immatériel, c’est la partie inclusion. C’est la première fois que la France va organiser les Jeux Paralympiques d’été. On voit bien aujourd’hui qu’il y a encore une certaine discrimination dans notre pays. Les  12 millions de Français qui vivent en situation de handicap ont moins accès à la pratique sportive, à l’emploi et au transport. Là aussi, à notre petit niveau et avec beaucoup d’humilité, on essaie de démontrer que le sport doit évoluer aﬁn que les clubs puissent accueillir davantage d’athlètes en situation de handicap. Ces fameux 3 000 clubs para-accueillants doivent voir le jour, alors qu’aujourd’hui nous n’en sommes seulement qu’à quelques centaines. Nous mettons en place des formations de cadres pour recevoir ces athlètes, tandis que l’État met en conformité l’accès aux installations sportives. Nous espérons ainsi avoir éveillé un peu les Français sur le fait que l’organisation des Jeux Paralympiques doit aussi nous montrer qu’il est possible d’être plus inclusif. Si nous parvenons à cela, les Jeux Olympiques et Paralympiques de Paris 2024 seront réussis.  1 «Terre de Jeux 2024» a pour objectif d’impliquer tous les territoires français dans les Jeux."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 61,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg62.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 62-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/62-line-1.png\"/>\n        <img id=\"62-quote-1\" class=\"halfScaleC\" style=\"top:84px;left:11px\" src=\"/120/static/_content/62-quote-1.png\"/>\n        <img class=\"halfScale 62-line-1\" style=\"top:176px;left:45px\" src=\"/120/static/_content/62-line-1.png\"/>\n        <img class=\"halfScale 62-title-1\" style=\"top:178px;left:84px\" src=\"/120/static/_content/62-title-1.png\"/>\n        <img id=\"62-img-1\" class=\"halfScaleC\" style=\"top:189px;left:-75px\" src=\"/120/static/_content/62-img-1.png\"/>\n        <img class=\"halfScale 62-sub-1\" style=\"top:626px;left:83px\" src=\"/120/static/_content/62-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg62Anim = new TimelineMax();\n          pg62Anim\n            .fromTo(cOf(\"62-line-1\"), 0.6, {opacity:0, y:40},{opacity:1, y:0, ease: Power2.easeOut}, 1)\n            .fromTo(idOf(\"62-quote-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(cOf(\"62-title-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.3)\n            .fromTo(idOf(\"62-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n            .fromTo(cOf(\"62-sub-1\"), 0.6, {opacity:0, x:40},{opacity:1, x:0, ease: Power2.easeOut}, 1.5)\n        }\n\n        function onPageLeave() {\n          pg62Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ì  le sport doIt Ítre inclusif  pierre rabadan est un ancien joueur de rugby à quinze et à sept. Il a joué en équipe de France au poste de troisième ligne aile au Stade français durant dix-sept ans. En 2020, il est élu adjoint au sport et aux Jeux Olympiques et Paralympiques 2024 à la mairie de Paris.  D  epuis la phase de candidature, nous nous sommes toujours positionnés sur le fait de savoir comment on pouvait faire évoluer le modèle des Jeux Olympiques. L’important était de préserver l’ambition donnée à ces Jeux: être novateurs et bénéﬁcier tant aux territoires dans lesquels ils se déroulent qu’à leurs habitants, rechercher de nouveaux publics et aussi jouer sur la jeunesse. Cela est vrai en particulier dans Paris en respectant à la lettre l’Agenda olympique 2020 et 2020+5, en adaptant les stades en place et en ne construisant que le strict nécessaire au bon déroulement des 17 jours de compétitions. Il n’était pas question pour nous, comme ce fut le cas par le passé, de voir des stades inutilisés après l’événement. En fait, nous n’avons jamais fait la di%érence entre ce que nous avions à faire pour réussir d’excellents Jeux et l’héritage qui devait en découler, car les deux sont liés. Optimiser l’utilisation des infrastructures mais aussi les coûts est normal et nécessaire. Notre objectif depuis le début est de respecter les engagements ﬁnanciers des Jeux. Il est logique de revoir les possibilités d’ajustement des coûts et de maximisation des recettes. C’est le cas avec le stade Jean Bouin, dédié au rugby, qui accueille chaque année les World Series de rugby à sept. À titre personnel, j’y ai un attachement particulier et j’aurais aimé voir le rugby dans l’antre du Stade français. Mais il faut avouer qu’avec son transfert au Stade de France, cela permet d’envisager une recette plus importante, ce qui est appréciable. C’est aussi le cas du mur d’escalade qui a été transféré de la Concorde au Bourget, là où il sera pérenne. L’e%icacité prime et la Seine-Saint-Denis a le plus besoin de proﬁter de cet événement: ses piscines et celles de Marville et d’Aubervilliers vont permettre à sa jeunesse de progresser. Dans une ville comme Paris avec une forte densité et peu d’espace, nous voulons continuer, comme lors de la précédente mandature, à entretenir et développer le parc sportif de 500 équipements, améliorer la qualité et accompagner le développement de nouvelles pratiques. Notre objectif est aussi que le sport permette une meilleure insertion avec des lieux d’accompagnement social et administratif autour d’un club sportif. Le sport doit être inclusif et nous n’allons pas fuir nos responsabilités. Nous nous sommes donc servi des Jeux Olympiques pour"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 62,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg63.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Revue Olympique  63  Numéro 120  1  accélérer un certain nombre d’investissements que nous avons mis en place en 2018, dès le lendemain de l’élection de la capitale comme ville hôte, à Lima (Pérou), en septembre 2017. Nous avons entrepris un grand nombre de travaux sur les équipements sportifs de toute la capitale, et nous allons faire en dix ans ce qui aurait pris plus de trente ans si nous n’avions pas eu les Jeux Olympiques. Ainsi, plusieurs dizaines d’endroits proﬁtent de «rafraîchissements» et même de créations. Nous avons des couvertures de terrains d’éducation physique, des créations de playgrounds de basket 3×3, des rénovations de gymnases et de centres sportifs, de piscines, de pistes d’athlétisme, la mise en place de nouveaux équipements et la réfection de gazon. Ces mises à niveau n’auraient jamais été possibles, en tout cas aussi rapidement, s’il n’y avait pas eu les Jeux. Les sites les plus connus sont la piscine des Tourelles, qui a reçu la natation en 1924, le stade Pierre de Coubertin,  la halle Carpentier ou encore le vélodrome de Vincennes, des monuments du sport français. Tous ces travaux qui ont pour but de développer la pratique sportive, surtout chez les jeunes, sont réalisés avec des matériaux plus durables que par le passé. Il nous reste encore beaucoup à faire pour recevoir les Jeux Olympiques l’an prochain: améliorer les voies cyclables – nous en avons plus de 60 km actuellement et le public pourra rejoindre les nombreux sites de compétition à vélo – mais aussi mettre en place la voie olympique sur le périphérique qui devrait se transformer, au lendemain des Jeux, en voie de covoiturage. Dans une ville patrimoniale et historique comme Paris, nous allons tenter d’améliorer le plus possible l’accessibilité des personnes en situation de handicap.  1 Le Stade de France sera transformé en stade olympique l’année prochaine.  Nous sommes également ﬁers d’être parvenus à exaucer le vœu de Jacques Chirac de pouvoir se baigner dans la Seine. Il a fallu des années pour y arriver et un investissement de 1,4 milliard d’euros. Plusieurs personnes s’y sont cassé les dents, car cette récupération de l’eau propre passe par toutes les collectivités en amont: par la Marne, par l’Yonne – mais nous y sommes parvenus. La première épreuve dans la Seine (natation marathon) est une récompense du travail collectif engagé sous l’égide du préfet de Paris et d’Île-de-France. La qualité de l’eau est bonne puisque les tests réalisés à l’été 2022 sur la période des Jeux (du 26+juillet au 11 août) ont montré que la qualité de la Seine était excellente sur 90% des jours. Un ponton, près du pont Alexandre III, côté Rive gauche, sera aménagé pour les nageurs en eau libre aﬁn d’accéder directement au ﬂeuve. Les Jeux ne vont pas résoudre tous les problèmes du sport français, mais Paris y a apporté sa part. ■"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 63,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg64.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 64-title\" style=\"top:44px;left:44px\" src=\"/120/static/_content/64-title-1.png\"/>\n        <img class=\"halfScale 64-sub\" style=\"top:295px;left:455px\" src=\"/120/static/_content/64-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg64Anim = new TimelineMax();\n          pg64Anim.fromTo(cOf(\"64-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"64-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg64Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "le poInt de vue des athlËtes DES ATHLÈTES ISSUS DE CINQ DISCIPLINES DIFFÉRENTES EXPLIQUENT POURQUOI LES JEUX OLYMPIQUES ET PARALYMPIQUES DE PARIS 2024 VONT CHANGER LA DONNE."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 64,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg65.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 65-title-1\" style=\"top:126px;left:55px\" src=\"/120/static/_content/65-title-1.png\"/>\n        <img class=\"halfScale 65-sub-1\" style=\"top:204px;left:56px\" src=\"/120/static/_content/65-sub-1.png\"/>\n        <img id=\"65-img-1\" class=\"halfScaleC\" style=\"top:188px;left:7px\" src=\"/120/static/_content/65-img-1.png\"/>\n        <img id=\"65-img-2\" class=\"halfScaleC\" style=\"top:203px;left:99px\" src=\"/120/static/_content/65-img-2.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:123px;left:54px;width:133px;height:37px;\"><a href=\"https://olympics.com/fr/athletes/alistair-brownlee\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:160px;left:54px;width:163px;height:37px;\"><a href=\"https://olympics.com/fr/athletes/alistair-brownlee\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg65Anim = new TimelineMax();\n          pg65Anim\n            .fromTo(cOf(\"65-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"65-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"65-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"65-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg65Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "alIstaIr brownlee  grande-bretagne, trIathlon  olympIen TM  mÈdaIlle díor  mÈdaIlle díor  J  e suis toujours impatient à l’approche des Jeux Olympiques, et ceux de Paris ne font pas exception, mais je pense que cette édition sera encore plus spéciale, car elle se déroule post-COVID. Tokyo 2020 a été formidable, avec des compétitions fantastiques, mais il manquait certains ingrédients qui vont revenir en force à Paris. Nous allons revoir l’ensemble du monde sportif dans une même ville pour deux semaines magiques et je pense que Paris sera un hôte extraordinaire. J’ai vraiment hâte  de retrouver le public. Les athlètes ont envie de se confronter et d’évoluer sur la plus grande des scènes, devant d’immenses foules et dans l’ambiance incroyable que seules les Jeux savent offrir. Je les cite toujours comme les moments les plus mémorables de ma carrière de triathlète. L’excitation et la préparation, ce sentiment incroyable lorsque vous approchez de la ligne de départ, les cris de la foule qui vous encourage… Le triathlon de Paris 2024 se déroulera en plein centre-ville, dans la Seine et sur les Champs-  Élysées. Il sera accessible et gratuit pour tous et aura lieu dans ces rues que les Parisiens utilisent tous les jours, sous leurs fenêtres. Tout cela participera à offrir une expérience inoubliable aux athlètes, dont la plupart auront déjà concouru à Paris. Le triathlon est une discipline populaire en France. L’affluence devrait être incroyable. De plus, ce sera le grand retour du relais mixte au programme olympique, c’est fantastique. Il s’agit d’un événement magniﬁque à bien des égards: l’équité – avec deux hommes et deux femmes –  et un format court qui donne une compétition frénétique et souvent très serrée! L’un des autres aspects uniques des Jeux Olympiques est de se retrouver avec des milliers d’athlètes venant du monde entier: des sports différents, des pays variés et des histoires vraiment singulières. C’est très spécial. Paris va ressusciter ce qui est pour moi le plus sensationnel dans les Jeux Olympiques: des personnes du monde entier qui se réunissent pour concourir ensemble et en paix."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 65,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg66.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 66-title-1\" style=\"top:84px;left:55px\" src=\"/120/static/_content/66-title-1.png\"/>\n        <img class=\"halfScale 66-sub-1\" style=\"top:164px;left:56px\" src=\"/120/static/_content/66-sub-1.png\"/>\n        <img id=\"66-img-1\" class=\"halfScaleC\" style=\"top:148px;left:7px\" src=\"/120/static/_content/66-img-1.png\"/>\n        <img id=\"66-img-2\" class=\"halfScaleC\" style=\"top:160px;left:99px\" src=\"/120/static/_content/66-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg66Anim = new TimelineMax();\n          pg66Anim\n            .fromTo(cOf(\"66-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"66-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"66-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"66-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg66Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "antoIne brIzard  france, volleyball  olympIen mÈdaIlle díor  L  a génération d’athlètes français dont je fais partie a la chance incroyable de pouvoir participer à des Jeux à domicile – la première fois depuis 100 ans. Paris 2024 doit être une vitrine de la France et des nouvelles idées qu’elle peut développer pour faire évoluer positivement le sport et les grands événements sportifs. Jusqu’ici, l’écologie n’a pas été une priorité dans le sport et nous savons que les grands rendez-vous sportifs ne peuvent malheureusement pas avoir un impact strictement positif. En revanche, Paris 2024 est l’occasion idéale pour agir avec exemplarité et sensibiliser à certains enjeux à la fois avant et pendant l’événement. Cela passe par ce que pouvons faire au quotidien pendant les Jeux, comme montrer qu’on peut limiter le gaspillage alimentaire, remplacer les bouteilles en plastique ou encore se passer de climatisation dans les stades. En tant qu’athlète, j’aimerais que chaque personne prenant part aux Jeux Olympiques et Paralympiques de Paris 2024 soit sensibilisée à au moins un geste écologique et puisse ramener cette pratique chez elle. Selon moi, l’erreur serait de penser que ce que nous pouvons faire individuellement ne change rien. Je ne prétends absolument pas être un exemple et ne suis pas un spécialiste en la matière: l’écologie est un sujet qui me touche, en tant que personne et en tant que sportif, alors j’essaie de faire le plus attention possible à mes actions dans la limite de mon possible et de mon activité. Aujourd’hui, le monde du sport doit évoluer aﬁn d’être le moins nocif possible pour la planète: cette transition, nous devons la mener tous ensemble et Paris 2024 doit montrer la voie."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 66,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg67.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 67-title-1\" style=\"top:242px;left:55px\" src=\"/120/static/_content/67-title-1.png\"/>\n        <img class=\"halfScale 67-sub-1\" style=\"top:326px;left:56px\" src=\"/120/static/_content/67-sub-1.png\"/>\n        <img id=\"67-img-1\" class=\"halfScaleC\" style=\"top:314px;left:7px\" src=\"/120/static/_content/67-img-1.png\"/>\n        <img id=\"67-img-2\" class=\"halfScaleC\" style=\"top:323px;left:103px\" src=\"/120/static/_content/67-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg67Anim = new TimelineMax();\n          pg67Anim\n            .fromTo(cOf(\"67-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"67-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"67-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"67-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg67Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "clarIsse agbÈgnÈnou france, judo  olympIenne  mÈdaIlle díor  2 mÈdaIlles díor  L  es Jeux à la maison, c’est plus que jamais l’occasion de véhiculer des messages forts et positifs autour du sport et de rappeler ses valeurs: le courage, la modestie, l’entraide, le respect, le fait qu’avec du travail tout devient possible… Pour moi, il est important que les Jeux Olympiques et Paralympiques de Paris 2024 fassent la promotion de ces valeurs auprès de la jeunesse. Revenir sur le tatami après avoir  donné naissance à ma ﬁlle [son premier enfant] n’a pas été facile. Après tous les changements liés à la grossesse, j’ai eu la sensation que j’allais devoir tout recommencer et me suis posé de nombreuses questions: «Est-ce que je vais réussir à retrouver mon meilleur niveau ?», «Vais-je réussir à gérer en parallèle ma vie d’athlète et ma vie de maman ?», etc. Personnellement, j’ai la chance d’être aidée au quotidien 2 par mes proches, grâce à qui je  peux m’entraîner dans les meilleures conditions et partir en compétition ou en stage tout en gardant ma ﬁlle à mes côtés. Si je devais faire passer un seul message aux acteurs du monde du sport, c’est qu’il faut faire davantage conﬁance aux athlètes désireuses d’avoir des enfants et s’attacher à les accompagner pour leur permettre de revenir à leur meilleur niveau. Tout le monde ne réalise pas la force, la détermination et les ressources  qu’une femme peut avoir. La maternité nous rend encore plus guerrières et les valeurs du sport prennent encore plus leur sens parce que ce sont précisément celles que l’on veut transmettre à nos enfants à travers leur éducation. Aujourd’hui, nous avons besoin de davantage d’exemples qui démontrent qu’il est tout à fait possible d’être à la fois mère et athlète de haut niveau: aux acteurs du sport de rendre possible ce changement!"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 67,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg68.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 68-title-1\" style=\"top:64px;left:55px\" src=\"/120/static/_content/68-title-1.png\"/>\n        <img class=\"halfScale 68-sub-1\" style=\"top:144px;left:56px\" src=\"/120/static/_content/68-sub-1.png\"/>\n        <img id=\"68-img-1\" class=\"halfScaleC\" style=\"top:128px;left:7px\" src=\"/120/static/_content/68-img-1.png\"/>\n        <img id=\"68-img-2\" class=\"halfScaleC\" style=\"top:140px;left:99px\" src=\"/120/static/_content/68-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg68Anim = new TimelineMax();\n          pg68Anim\n            .fromTo(cOf(\"68-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"68-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"68-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"68-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg68Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "arnaud assoumanI  france, athlÈtIsme handIsport  paralympIen  saut en longueur et trIple saut  mÈdaIlle de bronze  mÈdaIlle díor  2 mÈdaIlles díargent  PA RA LYM P IC GAME S  V  mÈdaIlle de bronze  ivre les Jeux chez soi, il n’y a rien de plus beau dans une carrière. J’ai eu la chance d’assister aux Jeux de Londres en 2012 et de voir la Grande-Bretagne remporter quatre titres au cours de la soirée. L’ambiance était incroyable! Alors évidemment, j’ai hâte de vivre ces Jeux à domicile, d’autant plus qu’ils seront placés sous le signe de l’inclusion. Si les Jeux de Paris 2024 seront inclusifs, c’est parce que le Comité d’organisation a souhaité  faire de ce sujet une priorité. Dès le début, cette volonté s’est traduite par des actions concrètes, comme la Semaine Olympique et Paralympique (SOP): dans ce cadre, en tant qu’athlète paralympique, je reçois chaque année de nombreuses demandes pour intervenir dans les écoles aﬁn de promouvoir le sport et de sensibiliser à la diversité. Mon constat, c’est qu’au ﬁl des années le sujet de l’inclusion intéresse de plus en plus de monde, ce qui est un bon signe.  Je suis convaincu que le sport est un puissant outil d’éducation et de partage de valeurs comme l’égalité et la solidarité. J’aimerais que chaque jeune puisse s’identiﬁer à un athlète, qu’il ait un handicap ou non. Car le handicap n’est pas une identité, tout comme la couleur de peau et l’orientation sexuelle ne le sont pas non plus: nous sommes avant tout des athlètes qui représentons notre pays dans toute sa diversité. Les stéréotypes, notamment ceux liés au handicap, Paris 2024  essaie de les casser, que ce soit par le biais du développement de 3 000 clubs para-accueillants, ou à travers la visibilité qui sera donnée aux Jeux Paralympiques. En effet, avec 300 heures de compétitions paralympiques diffusées en direct à la télévision, la France marquera l’histoire: jamais un tel temps d’antenne ne leur avait été accordé! Moi, je suis certain que les initiatives de Paris 2024 en faveur de l’inclusion laisseront un héritage durable dans le monde du sport et dans la société."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 68,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg69.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 69-title-1\" style=\"top:104px;left:55px\" src=\"/120/static/_content/69-title-1.png\"/>\n        <img class=\"halfScale 69-sub-1\" style=\"top:184px;left:56px\" src=\"/120/static/_content/69-sub-1.png\"/>\n        <img id=\"69-img-1\" class=\"halfScaleC\" style=\"top:168px;left:7px\" src=\"/120/static/_content/69-img-1.png\"/>\n        <img id=\"69-img-2\" class=\"halfScaleC\" style=\"top:180px;left:99px\" src=\"/120/static/_content/69-img-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg69Anim = new TimelineMax();\n          pg69Anim\n            .fromTo(cOf(\"69-title-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1)\n            .fromTo(cOf(\"69-sub-1\"), 0.6, {opacity:0, x:20},{opacity:1, x:0, ease: Power2.easeOut}, 1.1)\n            .fromTo(idOf(\"69-img-1\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n            .fromTo(idOf(\"69-img-2\"), 0.6, {scale:0}, {scale:0.5, ease: Back.easeOut.config(1.7), onComplete: addContentLinks}, 1.3)\n        }\n        function onPageLeave() {\n          pg69Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "annIIna tIkka (b-gIrl at) fInlande, breakIng  juge et athlËte modËle ‡ buenos aIres 2018  D  e nombreuses personnes vont bénéﬁcier de la présence du breaking à Paris 2024. C’est extrêmement excitant et important pour ce sport. De plus en plus d’enfants se mettent à pratiquer le breaking, car cette discipline gagne en visibilité et elle est davantage prise au sérieux: la pratique va se démocratiser, c’est même déjà le cas! La formation et l’encadrement sont également plus organisés, ce qui aide notamment à réduire les risques de blessures. À Paris, il y aura seulement les 16 meilleurs hommes et les 16 meilleures femmes [du monde], le niveau sera donc très élevé. Le fait que Paris 2024 propose la parité est déjà très positif. Lorsque j’ai commencé le breaking, c’était un monde très masculin, où les juges femmes étaient très rares. Par manque d’opportunités, peu de sportives parvenaient au sommet. Cela a beaucoup changé ces dernières années et la mentalité des organisateurs a évolué. Aujourd’hui, le niveau du breaking féminin est bien plus élevé, à force de conﬁance et d’opportunités. Plus de ﬁlles s’y mettent, car elles ont des exemples et voient ce qu’elles peuvent réaliser. Être maman présente également des déﬁs. J’ai la chance que la garde d’enfants soit abordable dans mon pays: ça m’offre la possibilité d’avoir plus de temps à consacrer à mon sport. Sans cela, il est très difficile de combiner le sport et le fait d’être parent. Autre difficulté: lorsque vous devenez maman, on suppose souvent que vous ne reprendrez pas votre carrière sportive. Je sais que certaines athlètes ont du mal à trouver des ﬁnancements et des sponsors, car il faut de nouveau faire ses preuves. Sans soutien, c’est difficile de retrouver son meilleur niveau. J’estime que les regards doivent changer sur ce point."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 69,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg70.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 70-title\" style=\"top:158px;left:42px\" src=\"/120/static/_content/70-title-1.png\"/>\n        <img class=\"halfScale 70-sub\" style=\"top:377px;left:43px\" src=\"/120/static/_content/70-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:395px;left:256px;width:56px;height:13px;\"><a href=\"https://olympics.com/en/news/forefront-of-womens-coaching-myriam-fox-jerusalmi\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:412px;left:40px;width:99px;height:13px;\"><a href=\"https://olympics.com/en/news/forefront-of-womens-coaching-myriam-fox-jerusalmi\" target=\"_blank\"></a></div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg70Anim = new TimelineMax();\n          pg70Anim.fromTo(cOf(\"70-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"70-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n          setTimeout(function(){\n            addContentLinks();\n          },1500)\n        }\n\n        function onPageLeave() {\n          pg70Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "un nouvel avenIr pour les entraÓneures fÈmInInes ENTRAÎNEURE DE L’ÉQUIPE AUSTRALIENNE DE CANOË ET DOUBLE OLYMPIENNE, MYRIAM FOX-JÉRUSALMI ÉVOQUE L’IMPORTANCE DE L’ÉGALITÉ DES GENRES AUX JEUX OLYMPIQUES DE PARIS 2024 ET PARLE DE L’AVENIR DES ENTRAÎNEURES FÉMININES. PAR CHARLI CASEY  L  es Jeux Olympiques de Paris 2024 regorgent d’occasions de se réjouir. Une cérémonie d’ouverture sur la Seine, ouverte à tous, sous le regard des habitants, des spectateurs du monde entier et de 10 500 athlètes. De nouveaux sports, dont les compétitions se dérouleront aux quatre coins de la ville, au lieu d’être cantonnées aux grands stades. Des célébrations quotidiennes pour les athlètes sur le Champ-de-Mars, sous la tour Eiffel…. Mais c’est une autre nouveauté qui inspire le plus Myriam Fox-Jérusalmi. Parmi les athlètes, il y aura 5 250 femmes et 5 250 hommes. Paris 2024 sera donc la première édition des Jeux Olympiques à parité parfaite. «Paris 2024 sera différent de tous les Jeux précédents à bien des niveaux», déclare la native de Marseille. «Ces Jeux vont servir de source d’inspiration à beaucoup de jeunes ﬁlles et garçons. L’égalité du nombre d’athlètes masculins et féminins participant à chaque discipline pourrait les inciter à poursuivre leurs rêves sportifs.  En entraînant sa ﬁlle Jessica, Myriam FoxJérusalmi l’a aidée à remporter 4 médailles d’or olympiques."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 70,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg71.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 71,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg72.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "1  «Les Jeux de Paris leur enverront un message: si vous voulez pratiquer un sport, faites-le. Si une jeune femme veut devenir boxeuse, ou si un jeune homme veut s’essayer à un sport plus artistique, cela devrait leur paraître naturel.» Sous l’impulsion de la politique d’égalité des genres, le nombre d’événements mixtes est passé de 18 à 22. Par ailleurs, 28 des 32 disciplines du programme olympique offriront une parité parfaite. Cela a été rendu possible grâce aux initiatives lancées par le CIO et concrétisées en partenariat avec Paris 2024, les Fédérations Internationales, les Comités Nationaux Olympiques, les diffuseurs et autres acteurs clés du Mouvement olympique. «C’est ainsi que les choses devraient être. L’égalité des genres devrait s’appliquer partout», souligne Fox-Jérusalmi. «Nous devrions offrir aux femmes les mêmes opportunités qu’aux hommes, dès le plus jeune âge, pour que l’égalité devienne la norme au plus haut niveau.» Toutefois, si de grands progrès ont été réalisés dans la parité des athlètes participant aux Jeux Olympiques, la sous-représentation des femmes parmi les entraîneurs d’élite demeure l’un des plus gros déﬁs du Mouvement olympique. À Tokyo 2020, les femmes représentaient seulement 13% de tous les entraîneurs accrédités sur l’ensemble des 33 sports. Le CIO s’est attaqué au problème  avec le programme WISH (Women in Sport High Performance Pathway), une initiative sur mesure déployée sur quatre ans et destinée à former une centaine de femmes à l’entraînement de haut niveau. Ce programme est soutenu par la Solidarité Olympique à hauteur d’un million de dollars américains. Forte de décennies d’expérience, FoxJérusalmi reconnaît que le poste d’entraîneur dans l’élite est exigeant, chronophage et souvent peu glamour. Elle estime qu’il lui a fallu beaucoup de courage et de conﬁance en elle  2  pour s’imposer dans un environnement quasiment exclusivement masculin et juge qu’il existe une certaine marge de progression dans l’accompagnement des femmes entraîneures qui ont ou souhaitent avoir des enfants. Pour elle, l’aspect pratique de la garde des enfants lors de longs déplacements est encore trop complexe, ce qui l’amène à proposer des pistes d’amélioration dans ce domaine. «Dans le sport de haut niveau, les entraîneures ne doivent pas s’inquiéter du temps qu’elles vont devoir passer avec leurs athlètes à l’étranger pour les compétitions», explique-t-elle. «Mais lorsque vous avez des enfants, il est impossible de ne pas prendre ça en compte. C’est difficile, sauf si vous pouvez bénéﬁcier du soutien de vos proches. «La nature de notre sport n’est pas simple. Les emplois du temps sont chargés. Avec une jeune famille, c’est extrêmement compliqué de pouvoir s’engager à partir pendant trois ou quatre semaines consécutives, surtout si vous ne vivez pas en Europe et que vous n’avez donc pas la possibilité de rentrer chez vous quelques jours et de repartir. «Les organisations sportives doivent trouver une manière d’apporter ce soutien. Cela passe peut-être par le fait d’envoyer deux entraîneurs au lieu d’un seul, ou peut-être de permettre aux femmes d’amener leurs enfants à certains stages. Ce type de soutien est fourni aux athlètes féminines – dans mon organisation, Paddle Australia, l’une des sprinteuses vient d’avoir un bébé et je suis sûre que l’instance va agir pour répondre à ses besoins de jeune maman. Mais ce n’est pas encore le cas pour les entraîneures.»"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 72,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg73.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 73-quote\" style=\"top:108px;left:43px\" src=\"/120/static/_content/73-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg73Anim = new TimelineMax();\n          pg73Anim.fromTo(cOf(\"73-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg73Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "Revue Olympique  73  Numéro 120  «Nous devrions offrir aux femmes les mêmes opportunités qu’aux hommes, dès le plus jeune âge, pour que l’égalité devienne la norme.» myrIam fox-jÈrusalmI  Fox-Jérusalmi concède que les obstacles que les femmes entraîneures ressentent sont de l’ordre du ressenti personnel. Elle décrit toutefois la culpabilité à laquelle de nombreuses femmes sont confrontées: la possibilité de manquer une étape importante avec leurs enfants tandis qu’elles poursuivent leur carrière au niveau élite. «Lorsqu’elles exercent un métier prenant, certaines femmes sont déchirées entre la peur de ne pas voir leurs enfants grandir et leur besoin de se réaliser. Quoi qu’elles fassent, elles ressentent forcément un sentiment de culpabilité», développe-t-elle. «Dans mon cas, je me souviens ne pas avoir ressenti de culpabilité, dans un sens, car je savais que mes parents prenaient énormément de plaisir à passer du temps avec leurs petits-enfants pendant les trois semaines où j’étais en déplacement – tout le monde était heureux. Ce compromis fonctionnait pour nous. «Mais une fois, alors que je rentrais d’une tournée en Amérique du Sud, j’ai allumé mon téléphone à l’atterrissage et j’ai découvert un message disant que l’un de mes enfants était à l’hôpital, avec une fracture du bras. J’ai tout laissé à l’aéroport pour ﬁler directement à l’hôpital. C’est tellement étrange que ce genre de choses arrive toujours lorsque vous êtes absente. Ce sont des moments que vous ne récupérerez jamais.» La maternité a longtemps été un sujet important pour Fox-Jérusalmi. Elle a décidé d’avoir un enfant entre les Jeux Olympiques de Barcelone 1992 et ceux d’Atlanta 1996,  1 Fox-Jérusalmi montre à Jessica la médaille de bronze qu’elle a gagnée à Atlanta en 1996. 2 Sur le podium olympique, deux ans à peine après être devenue mère. 3 Célébrant la médaille d’or de Jessica en canoë-slalom C1 à Tokyo 2020.  deux éditions auxquelles elle a participé pour la France. La kayakiste explique que cette décision était alors rare à l’époque, et qu’elle n’était pas sûre de pouvoir revenir au plus haut niveau. Si elle a remporté la médaille de bronze dans le slalom K1 à Atlanta, deux ans après la naissance de sa ﬁlle aînée, il lui a fallu s’armer de patience pour voir s’ouvrir les portes du métier d’entraîneur. C’est à l’aube des Jeux Olympiques de Sydney 2000 que sa carrière d’entraîneure a progressivement débuté. L’équipe nationale de canoë d’Australie a offert un poste à son mari, Richard Fox, qui avait concouru en canoëslalom pour la Grande-Bretagne. La famille quittait alors Marseille avec ses deux enfants pour rejoindre les antipodes. Ayant quitté son emploi dans le sud de la France, Fox-Jérusalmi a commencé à entraîner l’équipe nationale en tant que bénévole, avec un planning allégé, avant de s’investir pleinement à la tête de l’équipe féminine à partir de 2004, tout en gardant un œil sur les jeunes prometteurs. «La sélection australienne avait besoin d’aide dans l’encadrement. J’y ai fait quelques heures de bénévolat et tout le monde savait que ma priorité, c’était ma famille», dit-elle. «Mes enfants m’accompagnaient et tout le monde était content. C’était du gagnant-  3  gagnant, car même si je ne donnais qu’un peu de mon temps, j’avais beaucoup d’expérience et ils étaient heureux de m’avoir à bord.» Parmi les jeunes ﬁlles dont Fox-Jérusalmi suivait la progression de près ﬁgurait sa ﬁlle, Jessica Fox, qui marchait dans les pas de ses parents. Sous la houlette de sa mère, Fox est devenue l’une des athlètes les plus titrés de tous les temps en canoë-slalom, avec 12 titres mondiaux. Son palmarès époustouﬂant compte quatre médailles olympiques, dont une d’or, et elle compte bien briller encore à Paris. Elle a décroché l’or olympique à Tokyo, dans la toute première épreuve féminine de C1 inscrite au programme olympique. Avant cette édition, les femmes pouvaient seulement concourir en kayak-slalom. Myriam Fox-Jérusalmi a joué un rôle central dans cet ajout, ayant de longue date milité pour le développement du niveau d’élite féminin. Elle concède que si sa ﬁlle a eu un surplus de motivation pour atteindre les sommets, c’est peut-être aussi parce qu’elle a grandi à une époque où l’égalité des genres s’est concrétisée. «Lorsque Jess avait 13 ans, nous militions fermement pour obtenir l’égalité des genres dans le canoë-kayak», explique-t-elle. «Elle en faisait partie et a vu notre volonté à faire"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 73,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg74.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "progresser les conditions des athlètes féminines dans notre sport. «Mon mari Richard nous a beaucoup soutenues. Il disait toujours: "
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 74,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg75.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "Get Ready For The Best"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 75,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg76.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 76-title\" style=\"top:161px;left:42px\" src=\"/120/static/_content/76-title-1.png\"/>\n        <img class=\"halfScale 76-sub\" style=\"top:351px;left:43px\" src=\"/120/static/_content/76-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg76Anim = new TimelineMax();\n          pg76Anim.fromTo(cOf(\"76-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"76-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg76Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "76  Opinion  opinion  L’accueil des Jeux Olympiques: un précieux acquis Alors que Paris s’apprête à célébrer le J-365 avant les Jeux Olympiques 2024, Sir Hugh Robertson – président de l’Association olympique britannique et ministre des Jeux Olympiques en 2012 – analyse l’héritage laissé par Londres 2012 sur le sport britannique.  Sir Hugh Robertson est le président de l’Association olympique britannique. Avant cela, il a été le ministre britannique des Sports et des Jeux Olympiques, responsable pour la livraison des Jeux Olympiques de Londres 2012 et a supervisé tous les aspects de budget, construction, gestion opérationnelle et héritage.  L  ancement dans un an. Voilà un jalon extrêmement important pour n’importe quelle édition des Jeux Olympiques. C’est une date qui captive réellement les esprits, mais aussi le moment où vous réalisez que cet événement incroyable, sur lequel vous travaillez depuis tant d’années, est soudain très proche. Pour tous ceux qui ont œuvré à Londres 2012, dont j’ai eu le privilège d’être, cette dernière année est un cycle de tests qui passe à la vitesse de la lumière. Nous avons dû nous assurer du bon fonctionnement de toutes les infrastructures que nous avions bâties; qu’il était possible de faire entrer et sortir un million de personnes du parc olympique en toute sécurité; que les liaisons entre transports publics fonctionnaient avec fluidité… Nous avons rapidement découvert que les gens quittaient les stades de manière bien différente de celle anticipée par les simulations informatiques: les humains ne sont pas des programmes! Mais c’est uniquement grâce aux tests que nous avons identifié ce problème. Toutefois, il n’a pas été possible de tester l’héritage à long terme que nous espérions générer. S’il n’existait aucune garantie, nous ne voulions rien laisser au hasard. Dès le départ, une idée s’était imposée: nous devions planifier l’héritage en même temps que les Jeux. Notre devise était qu’il fallait intégrer l’héritage dans chaque phase de la planification des Jeux, et nous avons défini cinq domaines clés. Le premier était l’héritage pour l’économie, de manière à encourager le  commerce, les investissements étrangers et le tourisme, ainsi que la croissance économique qu’ils susciteraient. Le deuxième concernait la régénération, à savoir l’impact des Jeux sur le quartier de Stratford. Le troisième héritage concernait la communauté, la manière dont les Jeux seraient un vecteur de rassemblement et une source d’inspiration pour toute une génération. Le quatrième était l’impact de l’accueil des Jeux Paralympiques sur la promotion de l’inclusion et le changement des regards sur les personnes en situation de handicap. Le cinquième et dernier était l’héritage sportif, ce que les Jeux pouvaient apporter au sport britannique. Il est fabuleux de se rendre au parc olympique Queen Elizabeth aujourd’hui et de se remémorer tous les moments historiques vécus par la délégation britannique. En contemplant le stade olympique, impossible de ne pas se souvenir du «Super Saturday» – sans doute la plus belle journée de l’histoire de l’athlétisme britannique. Il y a ensuite eu le vélodrome, qui a rugi chaque jour au rythme des médailles décrochées par la nation hôte. Puis les berges où de larges foules se rassemblaient autour des"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 76,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg77.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 77-quote\" style=\"top:473px;left:43px\" src=\"/120/static/_content/77-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg77Anim = new TimelineMax();\n          pg77Anim.fromTo(cOf(\"77-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg77Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "77  1  «Les Jeux peuvent redéfinir la manière dont le reste du monde perçoit votre pays.» sIr hugh robertson  écrans géants pour célébrer les podiums de tous les sites, à Londres et au-delà. D’autres souvenirs surgissent, comme l’image de ce lieu tel qu’il était autrefois: la plus grande friche industrielle au sein du périphérique qu’est l’autoroute M25. Difficile de se l’imaginer aujourd’hui, avec les familles qui se promènent dans le parc, le centre commercial animé et l’activité de la station de métro, où se croisent résidents et employés. Mais voilà un exemple fantastique de la manière dont le sport peut régénérer un quartier et tout ce qu’il peut apporter au quotidien aux habitants d’une ville. Tous ceux qui ont la chance d’habiter à Stratford de nos jours peuvent savourer ces immenses espaces verts. Ils peuvent y faire du jogging ou du vélo, profiter de la piscine, assister à un match de Premier League… Sans parler des terrains de hockey, des  cours de tennis et autres salles hébergés dans la Copper Box. Quelle transformation! C’est là que l’héritage sportif va au-delà du niveau de performance. À l’évidence, nous sommes extrêmement fiers des succès de notre élite, et en particulier du fait que la Grande-Bretagne ait remporté plus de médailles à Rio 2016 qu’à domicile. Cela n’avait jamais été accompli par un pays hôte: il s’agit d’un exploit extraordinaire. Les Jeux de Londres ont également embelli la réputation de la Grande-Bretagne dans l’organisation d’événements majeurs. Lors de la décennie qui les a suivis, le pays a accueilli un grand nombre de compétitions continentales et mondiales. Toutefois, l’héritage sportif va au-delà de ces domaines, et en particulier au niveau de la communauté et de l’éducation sportive. En préparant Londres 2012, nous avons mis en place un projet baptisé «Places People Play» qui a été la clé de voûte de notre héritage à destination du plus grand nombre, en aidant plus de personnes, de tous âges et conditions, à pratiquer un sport. Nous avons soutenu des clubs sportifs et amélioré des installations, en investissant notamment dans des enceintes multisports;  nous avons également recruté et formé des milliers de dirigeants sportifs afin d’organiser et d’encadrer les activités sportives pour chacun. Tout cela allait bien au-delà des nouvelles infrastructures que nous bâtissions au parc olympique, et qui sont désormais utilisées par la communauté: du centre aquatique au vélodrome en passant par la Copper Box, mais aussi aux sites temporaires qui ont été démontés et déplacés vers d’autres lieux après les Jeux. Tous ces héritages sportifs sont inextricablement liés entre eux, du niveau élite aux communautés locales. Lorsque nous préparions Londres 2012, nous avions pour habitude de dire: «Rien ne sert de tenter d’inspirer les jeunes gens à travers le sport s’ils n’ont pas de modèles positifs à suivre.» C’est pourquoi le succès d’athlètes comme Jessica Ennis et Chris Hoy à Londres a été si important. Mais pour s’appuyer sur ce succès, il vous faut les installations adaptées et l’opportunité d’offrir à chacun la possibilité d’avoir une pratique sportive. L’inspiration seule ne suffit pas. C’est pourquoi il est primordial d’être précis dans la manière dont vous définissez cet héritage, dont vous le concrétisez, et dont vous l’évaluez par la suite. Pour Londres 2012, nous avions cinq piliers: économie, régénération, sport, communauté et handicap. Mais le plus important nous a peut-être échappé: l’impact fabuleux que l’organisation des Jeux peut avoir sur le moral d’un pays. Elle peut modifier le regard sur une ville et redéfinir la manière dont le reste du monde perçoit votre pays. Paris et l’ensemble de la France le découvriront l’an prochain. Dans mes souvenirs, notre dernière année a été une litanie de pépins à résoudre. Mais une fois que les Jeux sont ouverts, le sport prend la place centrale et attire tous les regards. Après cela, Paris pourra savourer le concert de louanges pour ce qui sera une édition fantastique des Jeux Olympiques qui marquera son époque, à n’en pas douter. ■  1 Le succès d’athlètes tels que Chris Hoy a joué un rôle clé dans l’héritage sportif de Londres 2012."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 77,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg78.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 78-title\" style=\"top:161px;left:42px\" src=\"/120/static/_content/78-title-1.png\"/>\n        <img class=\"halfScale 78-sub\" style=\"top:297px;left:43px\" src=\"/120/static/_content/78-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg78Anim = new TimelineMax();\n          pg78Anim.fromTo(cOf(\"78-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"78-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg78Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "78  Opinion  opinion  Changer le visage d’une ville Bill Morris décrit comment les Jeux Olympiques et d’autres événements majeurs peuvent avoir un impact positif et à long terme sur la ville hôte.  Bill Morris a été directeur des Cérémonies, de l’Éducation et des Live Sites pour Londres 2012. Il est conseiller senior auprès du CIO depuis une décennie. Administrateur de l’association «Spirit of 2012», il a récemment obtenu une maîtrise en développement urbain durable à l’Université d’Oxford. Les conclusions de la commission d’enquête nationale sur l’impact social des événements sont disponibles sur www.spiritof2012.org.uk (en anglais). Un exemplaire du mémoire de recherche de Bill Morris pour Oxford est disponible au Centre d’Études Olympiques.  C  hacune de mes visites au parc olympique de Londres 2012 génère chez moi autant d’ardeur que d’appréhension. Si ce trajet en métro sur la Central Line jusqu’à Stratford se traduit par un tel tourbillon d’émotions, c’est pour des raisons tant personnelles qu’académiques. Dans les deux cas, elles sont liées à l’impact à long terme des Jeux sur cette capitale mondiale, ou toute autre ville, car cela s’attaque à la problématique complexe du développement urbain durable. Les milliers de personnes qui ont travaillé sur Londres 2012 (ou à d’autres éditions des Jeux) ont vécu une expérience stimulante, épuisante et euphorique qui les marqueront à jamais, sur le plan personnel comme professionnel. Et tout se retrouve incarné dans le parc olympique. C’est pourquoi je m’inquiète à chaque fois que je retourne au stade qui a vu l’extraordinaire cérémonie d’ouverture de Danny Boyle et les triomphes sportifs qui l’ont suivie, bercés par un festival remarquable de fierté nationale. J’imagine ma détresse si un jour, en émergeant de Stratford Station, je trouvais ce lieu déserté, envahi par les herbes sauvages et balayé par les vents… Cela trahirait l’essence du capital humain investi dans les Jeux Olympiques de Londres 2012. Au-delà de l’émotion, cela donne un aperçu de l’impact persistant de Jeux sur sa communauté urbaine. J’ai eu la chance de l’évaluer ces dernières années, à la fois dans le cadre de ma maîtrise à l’Université d’Oxford, puis en tant que membre de la commission d’enquête nationale britannique sur l’impact social des événements. Tout cela m’a donné l’opportunité d’analyser non seulement si les grands événements mondiaux pourraient être plus durables,  mais aussi s’ils pouvaient servir de vecteurs de durabilité sociale et physique pour les communautés qui les accueillent. Lors de mes études à Oxford, j’ai pris comme cas d’études principaux les Jeux de Londres et de Rio, tout en examinant les projets pour Paris, Los Angeles et Brisbane. J’ai adopté une approche mixte, mêlant analyse de documents existants et 36 entretiens avec des leaders de tous bords, travaillant dans l’accueil, l’organisation et l’évaluation de Jeux Olympiques d’été. En parallèle, la commission d’enquête nationale (soutenue par le «Spirit of 2012 Trust») a passé 14 mois à étudier l’impact d’événements de tailles diverses, organisés aux quatre coins du pays en interrogeant participants, communautés, experts et chercheurs. Elle s’est concentrée sur les événements sportifs, mais aussi sur le programme britannique «City of Culture» et sur des événements nationaux comme le Jubilé royal. La question était la même: comment créer et optimiser une valeur positive durable, en usant comme catalyseur ces événements, et en particulier le plus grand d’entre eux: les Jeux Olympiques. Ce qui nous ramène au quartier East End de Londres. En émergeant de la station de métro, je contemple le parc olympique Queen Elizabeth, dans lequel se côtoient des groupes très divers: adeptes du shopping, employés se dirigeant vers les tours 1 rutilantes, jeunes urbains qui se rendent dans les galeries d’art et les centres culturels, familles cherchant le meilleur endroit pour pique-niquer, ainsi que des athlètes, fans et bénévoles arpentant les sentiers menant aux installations sportives. Une fois encore, mes craintes n’étaient pas fondées. Le parc fourmille de vie et arbore des grues qui préfigurent des développements futurs. Les urbanistes de 2012 ont créé cette nouvelle communauté au cœur d’un magnifique parc, bien desservi par les transports publics, afin de régénérer des friches industrielles polluées et oubliées depuis longtemps. Ils y ont bâti des logements sociaux et des projets immobiliers, des emplois variés, des écoles, des magasins, des outils technologiques, ainsi que des structures dédiées à la culture, au sport et à la santé; le tout, autour du premier parc urbain inauguré à Londres depuis des décennies. La plupart des"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 78,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg79.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 79-quote\" style=\"top:406px;left:43px\" src=\"/120/static/_content/79-quote-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg79Anim = new TimelineMax();\n          pg79Anim.fromTo(cOf(\"79-quote\"), 0.8, {opacity:0, x:20},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n        }\n\n        function onPageLeave() {\n          pg79Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "79  être la panacée: établissez donc une liste restreinte et réaliste de cibles majeures de durabilité (santé publique, climat/ neutralité énergétique, transports publics, équité sociale, ou autres «Objectifs de développement durables (ODD) des Nations Unies» et dégagez un consensus sur l’objectif principal. 3. Bâtissez des structures de gouvernance en équilibrant et intégrant les besoins de l’événement avec la planification à long terme et la cohésion sociale. 4. Assurez-vous que les financements et les consensus politiques visent le long terme et non uniquement l’événement. 1  «N’oubliez pas que l’événement principal doit être une réussite pour pouvoir générer un impact durable.» bIll morrIs  observateurs et chercheurs estiment que ce parc olympique est une réussite et qu’il offre un modèle de durabilité urbaine. Ce n’est hélas pas l’image qu’associent traditionnellement les médias à l’impact des événements majeurs. Quelles leçons peuvent donc être tirées de l’expérience du parc olympique Queen Elizabeth? Il s’agit tout d’abord du résultat d’une vision claire, sur le long terme. À l’aube du nouveau millénaire, le maire de Londres a uniquement soutenu la candidature de Londres 2012 car il y voyait une opportunité de mettre en place un programme de régénération sur 30 ans du quartier déshérité de l’East End. Vu l’étendu des besoins, il estimait que seul l’accueil d’un événement à résonnance mondiale lui permettrait d’assurer le soutien politique et les financements nécessaires. Il a ensuite fallu créer des structures de gouvernance appropriées et dédiées, qui puissent diriger et rendre des comptes sur  le projet – non seulement dans la phase initiale de construction, mais aussi sur son développement à long terme. L’Olympic Development Authority et le comité d’organisation des Jeux Olympiques ont œuvré lors de la phase de lancement, avant de transmettre le projet à l’issue des Jeux à la London Legacy Development Corporation qui en demeure l’instance de planification et de supervision, une décennie plus tard. Ces structures ont assuré des financements pérennes et une certaine indépendance face aux aléas de l’agitation politique. Avec ces éléments, les témoignages recueillis lors de mes recherches et les conclusions de la commission d’enquête nationale, voici les conseils adressés aux futurs pays hôtes de Jeux Olympiques et d’autres événements majeurs: 1. Définissez les besoins durables (physiques, sociaux et économiques) de votre communauté à long terme et évaluez avec précaution la mesure dans laquelle l’accueil d’un événement pourrait être le catalyseur dont vous avez besoin. Si c’est le cas, considérez les Jeux non comme un simple événement, mais comme le point pivot d’un programme de développement durable sur 20 ou 30 ans. 2. Les Jeux Olympiques (et autres événements majeurs) ne peuvent pas  5. L’événement principal doit être une réussite pour pouvoir générer un impact durable. La planification à long terme devrait y contribuer. Mes recherches ont été indépendantes du CIO, mais il est de bon augure que le Mouvement olympique montre l’exemple dans l’adoption de plusieurs de ces principes, pas seulement en tant que conseils aux candidats potentiels, mais dans sa propre vision et planification des futurs Jeux. Les envisager comme des catalyseurs pour des communautés durables est non seulement une bonne nouvelle pour les villes, mais aussi pour assurer le succès et la durabilité des Jeux Olympiques futurs. Les lecteurs attentifs auront remarqué que j’ai soigneusement omis le mot «héritage». Si ce concept n’a jamais été plus pertinent, les personnes interrogées dans le cadre de mes recherches estiment toutes qu’il est galvaudé et qu’il ne reflète pas la longue période de planification qui s’étend avant aussi bien qu’après les Jeux, et qu’il est souvent employé de manière nébuleuse, a posteriori et pour «faire joli». Je laisse ceci à votre appréciation. Maintenant que ce débat est lancé, je vais me préparer pour ma prochaine visite au parc olympique Queen Elizabeth… ■  1 Le parc olympique Queen Elizabeth reste toujours un lieu très actif. Cette photographie (ci-dessus) est prise 10 ans après Londres 2012."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 79,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg80.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 80-title\" style=\"top:77px;left:42px\" src=\"/120/static/_content/80-title-1.png\"/>\n        <img class=\"halfScale 80-sub\" style=\"top:145px;left:43px\" src=\"/120/static/_content/80-sub-1.png\"/>\n\n        <div class=\"addContentLinkThree\" style=\"top:227px;left:42px;width:202px;height:115px;\"><a href=\"https://library.olympics.com/Default/search.aspx?SC=CATALOGUE&QUERY=Coubertin+autographe&QUERY_LABEL=#/Search/(query:(InitialSearch:!t,Page:0,PageRange:3,QueryString:'Coubertin%20autographe',ResultSize:-1,ScenarioCode:CATALOGUE,SearchContext:0,SearchLabel:''))\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:227px;left:257px;width:92px;height:115px;\"><a href=\"https://library.olympics.com/Default/doc/SYRACUSE/2954165/tokyo-2020-official-report-the-tokyo-organising-committee-of-the-olympic-and-paralympic-games\" target=\"_blank\"></a></div>\n        <div class=\"addContentLinkThree\" style=\"top:227px;left:475px;width:82px;height:115px;\"><a href=\"https://library.olympics.com/Default/doc/SYRACUSE/2953854/olympic-sport-organisations-in-times-of-crisis-and-change-guide-for-strategic-management-and-good-go\" target=\"_blank\"></a></div>\n\n        <div class=\"addContentLinkThree\" style=\"top:823px;left:195px;width:134px;height:13px;\">\n          <a href=\"mailto:studies.centre@olympic.org\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:823px;left:342px;width:195px;height:13px;\">\n          <a href=\"https://olympics.com/cio/centre-etudes-olympiques\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:252px;width:110px;height:13px;\">\n          <a href=\"https://www.facebook.com/OlympicStudiesCentre/\" target=\"_blank\"></a>\n        </div>\n\n        <div class=\"addContentLinkThree\" style=\"top:836px;left:377px;width:100px;height:13px;\">\n          <a href=\"https://library.olympics.com/default.aspx?_lg=fr-FR\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg80Anim = new TimelineMax();\n          pg80Anim.fromTo(cOf(\"80-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"80-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut, onComplete: addContentLinks}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg80Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "80  Études olympiques  dernIËres parutIons Les dernières parutions recensées par le Centre d’Études Olympiques du CIO, votre source de connaissance olympique.  coubertIn autographe: 1915−1937  Vingt ans après Coubertin autographe: 1889-1915, voici le tome II, 1915-1937. Ce nouveau recueil de lettres et manuscrits de Pierre de Coubertin nous réserve de nouvelles découvertes et éclaire les deux dernières décennies de son existence: l’installation du CIO à Lausanne le 10 avril 1915, la Première Guerre mondiale, l’adieu au Mouvement olympique et ses dernières années, jusqu’à sa mort survenue le 2 septembre 1937. L’objectif de Jean Durry reste le même: rendre les écrits de Coubertin accessibles à tous et ainsi mettre en lumière cet homme hors du commun. Ce volume intègre plus largement les réponses des interlocuteurs de Coubertin et inclut de nombreux documents qui complètent de manière signiﬁcative les lettres et manuscrits, jusqu’alors seuls pris en compte. De plus, Durry met en perspective les lieux, les acteurs, les circonstances et ressuscite bien des faits oubliés ou ignorés.  auteur: Jean Durry. publiÈ avec le support du CIO, 2023, 484 pages, en français.  rapport offIcIel de tokyo 2020 Le Rapport officiel de Tokyo 2020 contient trois tomes et un ﬁlm documentaire. Le premier tome constitue le cœur du rapport: il propose une description exhaustive du travail mené par le comité d’organisation et les instances liées pour la préparation et l’organisation des Jeux. Le chapitre 1 décrit le contexte et le report des Jeux, ainsi que leurs philosophie et spéciﬁcités. Le chapitre 2 relate en détail les projets mis en œuvre pour créer un héritage autour de différents thèmes, tels que les sites et infrastructures de compétition, la gestion des Jeux, le relais de la ﬂamme olympique, les cérémonies, l’aspect marketing et la billetterie, ainsi que le domaine ﬁnancier. Le tome 2 est dédié aux photos mettant en valeur les temps forts du relais de la ﬂamme olympique et des compétitions. Le troisième tome donne des informations sur la structure organisationnelle du comité d’organisation.  olympic sport organisations in times of crisis and change guIde for strategic management and good governance Face aux déﬁs inédits et complexes que rencontre la société, les CNO doivent bâtir des stratégies aﬁn de rester en phase avec un environnement en perpétuelle évolution et tirer de bonnes conclusions. Développé en collaboration avec 11 CNO, les Comités olympiques européens (COE) et le bureau de représentation des COE auprès de l’UE, cet ouvrage est un guide novateur de gestion stratégique à destination des organisations sportives olympiques. Il aide à identiﬁer les changements et à fournir des outils pour les appliquer, puis à transformer les déﬁs et menaces inhérents en opportunités. Les auteurs fournissent des exemples et des meilleures pratiques, des recommandations et séances de formation à travers des ateliers et des études de cas.  ÈditÈ par: le Comité d’organisation des Jeux  auteurs: Holger Preuß, Christiana  Olympiques et Paralympiques de Tokyo. publiÈ par: le Comité d’organisation des Jeux Olympiques et Paralympiques de Tokyo, 2022, en anglais et en japonais.  Schallhorn et Norbert Schütte. publiÈ par: Academia Verlag, 2022, ISBN version papier: 9783985720637; et ebook: 9783985720644, 246 pages, en anglais.  pour en savoIr plus Pour des recherches historiques, factuelles et académiques, des ressources documentaires et des prêts de livres, consultez Olympic World Library ou contactez-nous. studies.centre@olympic.org olympics.com/ioc/olympic-studies-centre OlympicStudiesCentre library.olympics.com"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 80,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg81.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 81,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg82.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 82-title\" style=\"top:90px;left:42px\" src=\"/120/static/_content/82-title-1.png\"/>\n        <img class=\"halfScale 82-sub\" style=\"top:162px;left:43px\" src=\"/120/static/_content/82-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg82Anim = new TimelineMax();\n          pg82Anim.fromTo(cOf(\"82-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"82-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg82Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "82  Décès  dÈcËs Nous rendons hommage aux olympiens et aux personnalités du Mouvement olympique qui nous ont quittés.  bernard lapasset Ancien président de World Rugby qui a milité pour le retour du rugby aux Jeux. Bernard Lapasset, ancien président de la Fédération internationale de rugby, est décédé à l’âge de 75 ans. Il a également été président de la Fédération française de rugby de 1991 à 2008 et avait milité pour le retour du rugby dans le programme olympique. Après un second mandat à la tête de World Rugby en 2016, il avait concentré ses efforts sur la candidature de Paris pour les Jeux Olympiques de 2024, travaillant au côté de Tony Estanguet. Depuis 2018, Lapasset était président honoraire du comité d’organisation de Paris 2024. Il a été décoré de l’Ordre olympique en 2022 pour sa contribution au Mouvement olympique.  pat mccormick La quadruple championne olympique de plongeon Pat McCormick est décédée à l’âge de 92 ans. L’Américaine s’était imposée sur tremplin et en haut-vol lors des Jeux Olympiques d’Helsinki 1952, un exploit qu’elle rééditait à Melbourne 1956. Elle devenait ainsi la première plongeuse à être sacrée sur les épreuves de 3 mètres et 10 mètres dans deux Olympiades successives, un record égalé par Greg Louganis (États-Unis) à Los Angeles 1984 et Séoul 1988.  eli wolff Eli Wolff était un éducateur, athlète et militant qui a plaidé pour l’utilisation du sport comme outil pour le bien commun. Il est décédé à l’âge de 45 ans. Membre de l’équipe de football paralympique des États-Unis aux Jeux Paralympiques de 1996 et de 2004, Wolff a eu une vie pleine d’accomplissements, notamment en aidant à créer la Journée international du sport pour le développement et la paix. Il s’était également assuré que le sport soit inclus dans la Convention relative aux droits des personnes handicapées.  ralph boston Le triple médaillé olympique Ralph Boston nous a quittés à 83 ans. Le sauteur en longueur américain avait remporté l’or aux Jeux de Rome 1960, puis l’argent en 1964 et le bronze en 1968 pour compléter sa collection de médailles olympiques. Il a également établi six records mondiaux validés en saut en longueur, un record, entre 1960 et 1965. C’est en août 1960 qu’il a enregistré le premier, en sautant à 8,21 m pour battre le précèdent record établi 25 ans plus tôt par le grand Jesse Owens."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 82,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg83.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:120px;left:63px;height:23px;width:114px;\">\n          <a href=\"https://www.youtube.com/watch?v=CZsH46Ek2ao \" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": "Revue Olympique  83  Numéro 120  bob richards Seul homme à avoir remporté deux médailles d’or olympiques en saut à la perche, Bob Richards est décédé à 97 ans. L’Américain est monté sur la plus haute marche aux Jeux Olympiques de 1952 et 1956, après avoir remporté le bronze à Londres 1948. Avec trois médailles olympiques, c’est également le perchiste le plus décoré de l’histoire. Richards a été élu au Hall of Fame olympique américain en 1983, ainsi qu’au Hall of Fame de l’athlétisme américain en 1975.  dick fosbury Sauteur en hauteur légendaire, inventeur d’une technique révolutionnaire. Champion olympique et pionnier du saut en hauteur, Dick Fosbury est décédé à 76 ans. Il a été le premier athlète à sauter en réalisant un rouleau dorsal, créant une technique révolutionnaire qui a été baptisée en son honneur, le «Fosbury Flop». Vainqueur de la médaille d’or aux Jeux Olympiques de Mexico 1968 – en établissant au passage un nouveau record olympique à 2,24 m – l’Américain a révolutionné son sport, à tel point que les sauteurs utilisent encore aujourd’hui sa technique. Après sa retraite sportive, Fosbury est resté actif au sein du Mouvement olympique et paralympique. Il a également été vice-président de l’Association olympique et paralympique des États-Unis et président de l’Association mondiale des olympiens.  shozo sasahara L’athlète japonais Shozo Sasahara est décédé à l’âge de 93 ans. Il avait remporté la médaille d’or aux Jeux Olympiques de Melbourne 1956 dans la catégorie poids plumes, où il était également le porte-drapeau de la délégation nippone lors de la cérémonie d’ouverture. Sasahara avait aussi été couronné champion du monde deux ans plus tôt et, après avoir pris sa retraite sportive, il avait choisi de devenir entraîneur. Au cours de cette étape de sa vie, il s’est notamment occupé d’Osamu Watanabe, médaillé d’or dans la même discipline à Tokyo 1964. De 1989 à 2003, Sasahara a été président de l’Association de lutte japonaise, tout en étant vice-président de la Fédération internationale des luttes associées (devenue United World Wrestling, UWW), une instance dont il serait plus tard nommé vice-président honoraire. En 2006, il a été nommé au Panthéon international de la lutte UWW.  tori bowie Championne du monde 2017 sur 100 m et multi-médaillée olympique, Tori Bowie nous a quittés à l’âge de 32 ans. Au-delà de son sacre mondial en individuel, Bowie faisait également partie de l’équipe des États-Unis qui a remporté le 4×100 m aux Championnats du monde 2017 à Londres. Elle a par ailleurs décroché trois médailles olympiques à Rio 2016: l’or sur le 4×100 m, l’argent sur 100 m et le bronze au 200 m. Elle a aussi concouru au saut en longueur lors des Mondiaux 2019 à Doha (Qatar), terminant quatrième de l’épreuve féminine."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 83,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg84.jpg",
    "zoom": null,
    "content": "\n        <img class=\"halfScale 84-title\" style=\"top:78px;left:102px\" src=\"/120/static/_content/84-title-1.png\"/>\n        <img class=\"halfScale 84-sub\" style=\"top:138px;left:108px\" src=\"/120/static/_content/84-sub-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg84Anim = new TimelineMax();\n          pg84Anim.fromTo(cOf(\"84-title\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1)\n          .fromTo(cOf(\"84-sub\"), 0.8, {opacity:0, x:40},{opacity:1, x:0, ease: Power4.easeOut}, 1.3)\n        }\n\n        function onPageLeave() {\n          pg84Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "84  Le mot de la ﬁn  des premiËres historiques  Bien qu’un siècle les sépare, les Jeux Olympiques de Paris 1924 et 2024 resteront dans l’Histoire pour avoir marqué de nombreuses premières.  “Citius, Altius, Fortius” Devise utilisée dans le contexte des Jeux Olympiques  Construction d’un village olympique  Serment des athlètes formalisé Diffusion des Jeux en direct à la radio  Instauration du hissage de trois drapeaux à la cérémonie de clôture:  Utilisation de couloirs de nage dans les épreuves de natation  50%  CIO  50%  Nation hôte  Nation hôte des prochains Jeux  Parité entre les athlètes ètes hommess et femmes s Introduction du breaking a au programme o olympique  Villag des Village médias dédié média  Cérémonie d’ouverture organisée hors du stade olympique  Épreuves ouvertes au grand public (en athlétisme et cyclisme)  Règlements et techniques de compétition formalisés  Participation des territoires et communautés d’outre-mer"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 84,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg85.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLinkThree\" style=\"top:846px;left:542px;height:23px;width:150px;\">\n          <a href=\"https://samsung.com\" target=\"_blank\"></a>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n      }\n      ",
    "searchText": ""
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 85,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg86.jpg",
    "zoom": null,
    "content": "",
    "script": "\n        function onPageEnter() {\n        }\n\n        function onPageLeave() {\n        }\n      ",
    "searchText": "MERCI À NOS PARTENAIRES OLYMPIQUES MONDiAUX"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        var contentLinksThree = [].slice.call(document.querySelectorAll('.addContentLinkThree'))\n\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n        contentLinksThree.map(function callback(e) {\n          return e.className = 'contentLinkThree addContentLinkThree'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function pg16_gallery(index) {\n        Publish.openGalleryTwo([[\n          '1924-1.jpg',\n          '1924-2.jpg',\n          '1924-3.jpg',\n          '1924-4.jpg',\n          '1924-5.jpg',\n          '1924-6.jpg',\n          '1924-7.jpg',\n          '1924-8.jpg',\n          '1924-9.jpg',\n          '1924-10.jpg'\n        ], \n        index])\n      }\n\n      function pg52_gallery(index) {\n        Publish.openGalleryTwo([[\n          '2024-2.jpg',\n          '2024-3.jpg',\n          '2024-4.jpg',\n          '2024-5.jpg',\n          '2024-6.jpg',\n          '2024-7.jpg',\n          '2024-8.jpg',\n          '2024-9.jpg'\n        ], \n        index])\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 48;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-R0YMBV3MY6" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "OT+5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RkWL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q5L0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uvmt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.ae297d75e787d22051e5.js